<template>
  <div class="container-fluid">
    <!-- BreadCrumb -->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="setup-profile">
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-12 col-md-12">
          <div class="card card-top-line no-shadow">
            <div class="body page-card-head">
              <h6 class="mb-0 font-18">
                Let's get you started with a PayAngel Account
                <small class="d-block mt-3">
                  You're only a few clicks away! A world of possibilities awaits
                  for your payment and collection needs.
                </small>
              </h6>
              <img src="@/assets/checklist.png" class="img-fluid" alt="" />
            </div>
            <div class="body">
              <div class="setup-profile-collapse">
                <!-- Account Holder Information -->
                <div
                  class="profile-collapse-list account-holder-list active"
                  :class="accountHolder.accountHolderStatusColor"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.account_holder
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="accountHolder.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="accountHolder.Icon"
                      />
                      Account Holder Information
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="accountHolder.accountHolderStatusColor"
                      >
                        {{ accountHolder.accountHolderStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="account_holder"
                    accordion="profile-accordion"
                    role="tabpanel"
                    visible
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(accountHolderForm)"
                        id="accountholder_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <h6 class="mb-3 font-15">
                              <i class="fa fa-level-up fa-rotate-90"></i>
                              <strong>Tell us about yourself…</strong>
                            </h6>
                          </li>
                          <li>
                            <div class="row">
                              <div class="col-lg-3 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="title"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group form-select single-multiselect"
                                    :class="{
                                      errors: errors[0],
                                      success:
                                        accountHolder.title_selected &&
                                        !errors[0],
                                    }"
                                  >
                                    <span class="float-label">
                                      <label for="title">Title*</label>
                                      <multiselect
                                        placeholder=""
                                        v-model="accountHolder.title_selected"
                                        :searchable="false"
                                        :options="title_options"
                                      ></multiselect>
                                      <i
                                        class="fa fa-times"
                                        v-if="errors.length && errors[0]"
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="
                                          accountHolder.title_selected &&
                                          !errors[0]
                                        "
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-3 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="First Name"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !accountHolder.first_name,
                                      success: accountHolder.first_name,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.first_name"
                                        class="form-control"
                                        id="first_name"
                                        placeholder="First Name*"
                                      />
                                      <label
                                        for="first_name"
                                        class="control-label"
                                      >
                                        First Name*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !accountHolder.first_name
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.first_name"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-3 col-md-6 col-sm-12">
                                <div class="form-group">
                                  <span class="float-label">
                                    <input
                                      type="text"
                                      v-model="accountHolder.middle_name"
                                      class="form-control"
                                      id="middle_name"
                                      placeholder="Middle Name"
                                    />
                                    <label
                                      for="middle_name"
                                      class="control-label"
                                    >
                                      Middle Name
                                    </label>
                                    <div class="line"></div>
                                  </span>
                                </div>
                              </div>
                              <div class="col-lg-3 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="Last Name"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !accountHolder.last_name,
                                      success: accountHolder.last_name,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.last_name"
                                        class="form-control"
                                        id="last_name"
                                        placeholder="Last Name*"
                                      />
                                      <label
                                        for="last_name"
                                        class="control-label"
                                      >
                                        Last Name*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !accountHolder.last_name
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.last_name"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div class="row">
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="gender"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          accountHolder.gender && !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">Gender*</label>
                                        <multiselect
                                          placeholder=""
                                          v-model="accountHolder.gender"
                                          :show-labels="false"
                                          :options="gender_options"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            accountHolder.gender && !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>

                                <div class="head">
                                  <label class="mb-1">Date of Birth</label>
                                </div>
                                <ValidationProvider
                                  name="holer_dob"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !accountHolder.date_of_birth,
                                      success: accountHolder.date_of_birth,
                                    }"
                                  >
                                    <span class="float-label">
                                      <dropdown-datepicker
                                        :daySuffixes="false"
                                        month-format="short"
                                        display-format="dmy"
                                        v-model="accountHolder.date_of_birth"
                                      ></dropdown-datepicker>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !accountHolder.date_of_birth
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.date_of_birth"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>

                                <ValidationProvider
                                  name="cob"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          accountHolder.countryofBirth &&
                                          !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">
                                          Country of Birth*
                                        </label>
                                        <multiselect
                                          placeholder=""
                                          v-model="accountHolder.countryofBirth"
                                          :show-labels="false"
                                          :options="countryofBirth_options"
                                          :searchable="false"
                                          label="name"
                                          track-by="name"
                                        >
                                          <template
                                            slot="option"
                                            slot-scope="props"
                                          >
                                            <span
                                              :class="props.option.flagClass"
                                            ></span>
                                            <div class="option__desc">
                                              <span class="option__title">
                                                {{ props.option.name }}
                                              </span>
                                            </div>
                                          </template>
                                        </multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            accountHolder.countryofBirth &&
                                            !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>

                                <ValidationProvider
                                  name="email"
                                  rules="required|email"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        (errors.length &&
                                          !accountHolder.email_address) ||
                                        errors[0],
                                      success:
                                        accountHolder.email_address &&
                                        !errors[0],
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="email"
                                        v-model="accountHolder.email_address"
                                        class="form-control"
                                        name="email"
                                        id="email_address"
                                        placeholder="Email Address*"
                                      />
                                      <label
                                        for="email_address"
                                        class="control-label"
                                      >
                                        Email Address*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          (errors.length &&
                                            !accountHolder.email_address) ||
                                          errors[0]
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="
                                          accountHolder.email_address &&
                                          !errors[0]
                                        "
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>

                                <ValidationProvider
                                  name="Mobile Number"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !accountHolder.mobile_number,
                                      success: accountHolder.mobile_number,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.mobile_number"
                                        class="form-control"
                                        id="mobile_number"
                                        placeholder="Mobile Number*"
                                      />
                                      <label
                                        for="mobile_number"
                                        class="control-label"
                                      >
                                        Mobile Number*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !accountHolder.mobile_number
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.mobile_number"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>

                                <ValidationProvider
                                  name="role"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          accountHolder.your_role && !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">Your Role*</label>
                                        <multiselect
                                          placeholder=""
                                          v-model="accountHolder.your_role"
                                          :show-labels="false"
                                          :options="role_options"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            accountHolder.your_role &&
                                            !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>
                              </div>

                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="cor"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          accountHolder.countryofResidence &&
                                          !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">
                                          Country of Residence*
                                        </label>
                                        <multiselect
                                          placeholder=""
                                          v-model="
                                            accountHolder.countryofResidence
                                          "
                                          :show-labels="false"
                                          :options="countryofResidence_options"
                                          :searchable="false"
                                          label="name"
                                          track-by="name"
                                        >
                                          <template
                                            slot="option"
                                            slot-scope="props"
                                          >
                                            <span
                                              :class="props.option.flagClass"
                                            ></span>
                                            <div class="option__desc">
                                              <span class="option__title">
                                                {{ props.option.name }}
                                              </span>
                                            </div>
                                          </template>
                                        </multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            accountHolder.countryofResidence &&
                                            !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>

                                <div
                                  class="head d-none d-md-block blank-block-header"
                                >
                                  <label>&nbsp;</label>
                                </div>
                                <ValidationProvider
                                  name="holer_Address1"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !accountHolder.addressLine1,
                                      success: accountHolder.addressLine1,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.addressLine1"
                                        class="form-control"
                                        id="holer_Address1"
                                        placeholder="Address Line 1*"
                                      />
                                      <label
                                        for="holer_Address1"
                                        class="control-label"
                                      >
                                        Address Line 1*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !accountHolder.addressLine1
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.addressLine1"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>

                                <div class="form-group">
                                  <span class="float-label">
                                    <input
                                      type="text"
                                      v-model="accountHolder.addressLine2"
                                      class="form-control"
                                      id="holer_Address2"
                                      placeholder="Address Line 2"
                                    />
                                    <label
                                      for="holer_Address2"
                                      class="control-label"
                                    >
                                      Address Line 2
                                    </label>
                                    <div class="line"></div>
                                  </span>
                                </div>

                                <ValidationProvider
                                  name="holderTown"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length && !accountHolder.town,
                                      success: accountHolder.town,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.town"
                                        class="form-control"
                                        id="holderTown"
                                        placeholder="Town*"
                                      />
                                      <label
                                        for="holderTown"
                                        class="control-label"
                                      >
                                        Town*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length && !accountHolder.town
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.town"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>

                                <ValidationProvider
                                  name="holderCity"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length && !accountHolder.city,
                                      success: accountHolder.city,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.city"
                                        class="form-control"
                                        id="holderCity"
                                        placeholder="City*"
                                      />
                                      <label
                                        for="holderCity"
                                        class="control-label"
                                      >
                                        City*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length && !accountHolder.city
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.city"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>

                                <ValidationProvider
                                  name="holderSprc"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length && !accountHolder.sprc,
                                      success: accountHolder.sprc,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.sprc"
                                        class="form-control"
                                        id="holderSprc"
                                        placeholder="State/Province/Region/County*"
                                      />
                                      <label
                                        for="holderSprc"
                                        class="control-label"
                                      >
                                        State/Province/Region/County*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length && !accountHolder.sprc
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.sprc"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>

                                <ValidationProvider
                                  name="holderPostCode"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !accountHolder.postCode,
                                      success: accountHolder.postCode,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="accountHolder.postCode"
                                        class="form-control"
                                        id="holderPostCode"
                                        placeholder="Post/Zip Code*"
                                      />
                                      <label
                                        for="holderPostCode"
                                        class="control-label"
                                      >
                                        Post/Zip Code*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !accountHolder.postCode
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="accountHolder.postCode"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex flex-column flex-md-row justify-content-center"
                            >
                              <b-button variant="secondary btn-mw" size="lg">
                                Cancel
                              </b-button>
                              <b-button
                                type="submit"
                                variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                                size="lg"
                              >
                                Confirm &amp; Save
                              </b-button>
                            </div>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Basic Business Information -->
                <div
                  class="profile-collapse-list business-info"
                  :class="[
                    { active: accountHolder.accountHolderIsSubmit },
                    businessInfo.businessInfoStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.business_info
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="businessInfo.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="businessInfo.Icon"
                      />
                      Basic Business Information
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="businessInfo.businessInfoStatusColor"
                      >
                        {{ businessInfo.businessInfoStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="business_info"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="accountHolder.accountHolderIsSubmit"
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(businessInfoForm)"
                        id="businessInfo_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <h6 class="mb-3 font-15">
                              <i class="fa fa-level-up fa-rotate-90"></i>
                              <strong>
                                Tell us about your
                                {{ businessInfo.businessTypeTitle }}
                              </strong>
                            </h6>
                          </li>
                          <li>
                            <div class="head">
                              <label>
                                Where is your
                                {{ businessInfo.businessTypeTitle }} located?
                                <span class="text-danger">*</span>
                              </label>
                            </div>
                            <ValidationProvider
                              name="residence_country"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div class="country-dropdown">
                                <div
                                  class="form-group form-select multiselect-grp"
                                  :class="{
                                    errors: errors[0],
                                    success:
                                      businessInfo.residenceCountrys &&
                                      !errors[0],
                                  }"
                                >
                                  <span class="float-label">
                                    <label for="Country">
                                      Select
                                      {{ businessInfo.businessTypeTitle }}
                                      Country of Residence*
                                    </label>
                                    <multiselect
                                      placeholder=""
                                      v-model="businessInfo.residenceCountrys"
                                      :show-labels="false"
                                      :options="residence_countrys"
                                      :searchable="false"
                                      label="name"
                                      track-by="name"
                                    >
                                      <template
                                        slot="option"
                                        slot-scope="props"
                                      >
                                        <span
                                          :class="props.option.flagClass"
                                        ></span>
                                        <div class="option__desc">
                                          <span class="option__title">
                                            {{ props.option.name }}
                                          </span>
                                        </div>
                                      </template>
                                    </multiselect>
                                    <i
                                      class="fa fa-times"
                                      v-if="errors.length && errors[0]"
                                    ></i>
                                    <i
                                      class="fa fa-check"
                                      v-if="
                                        businessInfo.residenceCountrys &&
                                        !errors[0]
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div class="head">
                              <label>
                                Tell us about your
                                {{ businessInfo.businessTypeTitle }} Type or
                                Legal Form
                                <span class="text-danger">*</span>
                              </label>
                            </div>
                            <ValidationProvider
                              name="business_type"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group form-select single-multiselect"
                                :class="{
                                  errors: errors[0],
                                  success:
                                    businessInfo.businessType && !errors[0],
                                }"
                              >
                                <span class="float-label">
                                  <label for="functions">
                                    Select
                                    {{ businessInfo.businessTypeTitle }} Type*
                                  </label>
                                  <multiselect
                                    placeholder=""
                                    v-model="businessInfo.businessType"
                                    :options="businesstype_options"
                                    :show-labels="false"
                                    label="businessTypeTitle"
                                    track-by="businessTypeTitle"
                                    @input="onChangeBusiness"
                                  >
                                    <template slot="option" slot-scope="props">
                                      <span
                                        :class="{
                                          'text-info':
                                            props.option.businessType ==
                                            'organisation',
                                        }"
                                      >
                                        {{ props.option.businessTypeTitle }}
                                      </span>
                                    </template>
                                  </multiselect>
                                  <i
                                    class="fa fa-times"
                                    v-if="errors.length && errors[0]"
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="
                                      businessInfo.businessType && !errors[0]
                                    "
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li v-if="businessInfo.showOtherInput">
                            <ValidationProvider
                              name="Other"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !businessInfo.otherBusinessType,
                                  success: businessInfo.otherBusinessType,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessInfo.otherBusinessType"
                                    class="form-control"
                                    id="other_type"
                                    placeholder="Other*"
                                  />
                                  <label for="other_type" class="control-label">
                                    Other*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessInfo.otherBusinessType
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessInfo.otherBusinessType"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div class="head">
                              <label>
                                What’s the name of your
                                {{ businessInfo.businessTypeTitle }}?
                                <span class="text-danger">*</span>
                              </label>
                            </div>
                            <ValidationProvider
                              name="Business or Organisation"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !businessInfo.businessOrganisation,
                                  success: businessInfo.businessOrganisation,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessInfo.businessOrganisation"
                                    class="form-control"
                                    id="businessOrganisation"
                                    :placeholder="
                                      businessInfo.businessTypeTitle + 'Name*'
                                    "
                                  />
                                  <label
                                    for="businessOrganisation"
                                    class="control-label"
                                  >
                                    {{ businessInfo.businessTypeTitle }} Name*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessInfo.businessOrganisation
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessInfo.businessOrganisation"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Has your
                                {{ businessInfo.businessTypeTitle }} ever
                                changed its name?
                                <span class="text-danger">*</span>
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="changed_BusinessName"
                                  v-model="businessInfo.changedBusinessName"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="changed_BusinessName"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="businessInfo.changedBusinessName">
                            <ValidationProvider
                              name="Previous Business Name"
                              :rules="
                                businessInfo.changedBusinessName
                                  ? 'required'
                                  : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !businessInfo.previousBusinessName,
                                  success: businessInfo.previousBusinessName,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessInfo.previousBusinessName"
                                    class="form-control"
                                    id="previous_business"
                                    :placeholder="
                                      'Previous' +
                                      businessInfo.businessTypeTitle +
                                      'Name*'
                                    "
                                  />
                                  <label
                                    for="previous_business"
                                    class="control-label"
                                  >
                                    Previous
                                    {{ businessInfo.businessTypeTitle }} Name*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessInfo.previousBusinessName
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessInfo.previousBusinessName"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div class="head">
                              <label>
                                When did you start or register your
                                {{ businessInfo.businessTypeTitle }}?
                              </label>
                            </div>
                            <ValidationProvider
                              name="businessInfo_startdate"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !businessInfo.registerBusinessDate,
                                  success: businessInfo.registerBusinessDate,
                                }"
                              >
                                <span class="float-label">
                                  <dropdown-datepicker
                                    :daySuffixes="false"
                                    month-format="short"
                                    display-format="dmy"
                                    v-model="businessInfo.registerBusinessDate"
                                  ></dropdown-datepicker>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessInfo.registerBusinessDate
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessInfo.registerBusinessDate"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div class="head">
                              <label>
                                Approximately when did your
                                {{ businessInfo.businessTypeTitle }} start
                                trading?
                              </label>
                            </div>
                            <ValidationProvider
                              name="businessInfo_tradedate"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length && !businessInfo.startTrading,
                                  success: businessInfo.startTrading,
                                }"
                              >
                                <span class="float-label">
                                  <dropdown-datepicker
                                    :daySuffixes="false"
                                    month-format="short"
                                    display-format="dmy"
                                    v-model="businessInfo.startTrading"
                                  ></dropdown-datepicker>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessInfo.startTrading
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessInfo.startTrading"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Does your
                                {{ businessInfo.businessTypeTitle }} trade under
                                a name different from the one above?
                                <span class="text-danger">*</span>
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="displaytradingName"
                                  v-model="businessInfo.displaytradingName"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="displaytradingName"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="businessInfo.displaytradingName">
                            <ValidationProvider
                              name="trading_name"
                              :rules="
                                businessInfo.displaytradingName
                                  ? 'required'
                                  : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    (errors.length &&
                                      !businessInfo.tradingName) ||
                                    errors[0],
                                  success:
                                    businessInfo.tradingName && !errors[0],
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessInfo.tradingName"
                                    class="form-control"
                                    id="trading_name"
                                    placeholder="Trading Name*"
                                  />
                                  <label
                                    for="trading_name"
                                    class="control-label"
                                  >
                                    Trading Name*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      (errors.length &&
                                        !businessInfo.tradingName) ||
                                      errors[0]
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="
                                      businessInfo.tradingName && !errors[0]
                                    "
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm &amp; Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Business Contact Details -->
                <div
                  class="profile-collapse-list business-contact"
                  :class="[
                    { active: businessInfo.businessInfoIsSubmit },
                    businessContact.businessContactStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.business_contact
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="businessContact.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="businessContact.Icon"
                      />
                      {{ businessInfo.businessTypeTitle }} Contact Details
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="businessContact.businessContactStatusColor"
                      >
                        {{ businessContact.businessContactStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="business_contact"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="businessInfo.businessInfoIsSubmit"
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(businessContactForm)"
                        id="businessContact_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <h6 class="mb-3 font-15">
                              <i class="fa fa-level-up fa-rotate-90"></i>
                              <strong>
                                Tell us how to reach your
                                {{ businessInfo.businessTypeTitle }}…
                              </strong>
                            </h6>
                          </li>
                          <li>
                            <div class="row">
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="Address Line 1"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !businessContact.addressLine1,
                                      success: businessContact.addressLine1,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.addressLine1"
                                        class="form-control"
                                        id="address1"
                                        placeholder="Address Line 1*"
                                      />
                                      <label
                                        for="address1"
                                        class="control-label"
                                      >
                                        Address Line 1*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !businessContact.addressLine1
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.addressLine1"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <div class="form-group">
                                  <span class="float-label">
                                    <input
                                      type="text"
                                      v-model="businessContact.addressLine2"
                                      class="form-control"
                                      id="address2"
                                      placeholder="Address Line 2"
                                    />
                                    <label for="address2" class="control-label">
                                      Address Line 2
                                    </label>
                                    <div class="line"></div>
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="Town"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length && !businessContact.town,
                                      success: businessContact.town,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.town"
                                        class="form-control"
                                        id="town"
                                        placeholder="Town*"
                                      />
                                      <label for="town" class="control-label">
                                        Town*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length && !businessContact.town
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.town"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="city"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length && !businessContact.city,
                                      success: businessContact.city,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.city"
                                        class="form-control"
                                        id="city"
                                        placeholder="City*"
                                      />
                                      <label for="city" class="control-label">
                                        City*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length && !businessContact.city
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.city"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="sprc"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length && !businessContact.sprc,
                                      success: businessContact.sprc,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.sprc"
                                        class="form-control"
                                        id="sprc"
                                        placeholder="State/Province/Region/County*"
                                      />
                                      <label for="sprc" class="control-label">
                                        State/Province/Region/County*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length && !businessContact.sprc
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.sprc"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="postCode"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !businessContact.postCode,
                                      success: businessContact.postCode,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.postCode"
                                        class="form-control"
                                        id="postCode"
                                        placeholder="Post/Zip Code*"
                                      />
                                      <label
                                        for="postCode"
                                        class="control-label"
                                      >
                                        Post/Zip Code*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !businessContact.postCode
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.postCode"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is the registered
                                {{ businessInfo.businessTypeTitle }} address the
                                same as where you normally operate your
                                {{ businessInfo.businessTypeTitle }}?
                                <span class="text-danger">*</span>
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="tradingAddress"
                                  v-model="businessContact.tradingAddress"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="tradingAddress"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="businessContact.tradingAddress">
                            <div class="row">
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="tAddress_Line1"
                                  :rules="
                                    businessContact.tradingAddress
                                      ? 'required'
                                      : ''
                                  "
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !businessContact.tradingAddressInput1,
                                      success:
                                        businessContact.tradingAddressInput1,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="
                                          businessContact.tradingAddressInput1
                                        "
                                        class="form-control"
                                        id="tradingaddress1"
                                        placeholder="Address Line 1*"
                                      />
                                      <label
                                        for="tradingaddress1"
                                        class="control-label"
                                      >
                                        Address Line 1*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !businessContact.tradingAddressInput1
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="
                                          businessContact.tradingAddressInput1
                                        "
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <div class="form-group">
                                  <span class="float-label">
                                    <input
                                      type="text"
                                      v-model="
                                        businessContact.tradingAddressInput2
                                      "
                                      class="form-control"
                                      id="tradingaddress2"
                                      placeholder="Address Line 2"
                                    />
                                    <label
                                      for="tradingaddress2"
                                      class="control-label"
                                    >
                                      Address Line 2
                                    </label>
                                    <div class="line"></div>
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="tradingTTown"
                                  :rules="
                                    businessContact.tradingAddress
                                      ? 'required'
                                      : ''
                                  "
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !businessContact.tradingTown,
                                      success: businessContact.tradingTown,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.tradingTown"
                                        class="form-control"
                                        id="tradingTTown"
                                        placeholder="Town*"
                                      />
                                      <label
                                        for="tradingTTown"
                                        class="control-label"
                                      >
                                        Town*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !businessContact.tradingTown
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.tradingTown"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="tradingTCity"
                                  :rules="
                                    businessContact.tradingAddress
                                      ? 'required'
                                      : ''
                                  "
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !businessContact.tradingCity,
                                      success: businessContact.tradingCity,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.tradingCity"
                                        class="form-control"
                                        id="tradingTCity"
                                        placeholder="City*"
                                      />
                                      <label
                                        for="tradingTCity"
                                        class="control-label"
                                      >
                                        City*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !businessContact.tradingCity
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.tradingCity"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="tsprc"
                                  :rules="
                                    businessContact.tradingAddress
                                      ? 'required'
                                      : ''
                                  "
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !businessContact.tradingSprc,
                                      success: businessContact.tradingSprc,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="businessContact.tradingSprc"
                                        class="form-control"
                                        id="tsprc"
                                        placeholder="State/Province/Region/County*"
                                      />
                                      <label for="tsprc" class="control-label">
                                        State/Province/Region/County*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !businessContact.tradingSprc
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.tradingSprc"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="tradingpostCode"
                                  :rules="
                                    businessContact.tradingAddress
                                      ? 'required'
                                      : ''
                                  "
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !businessContact.tradingPostCode,
                                      success: businessContact.tradingPostCode,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="
                                          businessContact.tradingPostCode
                                        "
                                        class="form-control"
                                        id="tradingpostCode"
                                        placeholder="Post/Zip Code*"
                                      />
                                      <label
                                        for="tradingpostCode"
                                        class="control-label"
                                      >
                                        Post/Zip Code*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !businessContact.tradingPostCode
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="businessContact.tradingPostCode"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div class="head">
                              <label>
                                What’s the best mobile number for contacting the
                                {{ businessInfo.businessTypeTitle }}?
                                <span class="text-danger">*</span>
                              </label>
                            </div>
                            <ValidationProvider
                              name="Mobile Number"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !businessContact.mobileNumber,
                                  success: businessContact.mobileNumber,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessContact.mobileNumber"
                                    class="form-control"
                                    id="office_Address"
                                    placeholder="Mobile Number*"
                                  />
                                  <label
                                    for="office_Address"
                                    class="control-label"
                                  >
                                    Mobile Number*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessContact.mobileNumber
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessContact.mobileNumber"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div class="head">
                              <label>
                                What’s the best email for communicating with the
                                {{ businessInfo.businessTypeTitle }}?
                                <span class="text-danger">*</span>
                              </label>
                            </div>
                            <ValidationProvider
                              name="email"
                              rules="required|email"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    (errors.length && !businessContact.email) ||
                                    errors[0],
                                  success: businessContact.email && !errors[0],
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="email"
                                    v-model="businessContact.email"
                                    class="form-control"
                                    name="email"
                                    id="contact-email"
                                    placeholder="Email*"
                                  />
                                  <label
                                    for="contact-email"
                                    class="control-label"
                                  >
                                    Email*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      (errors.length &&
                                        !businessContact.email) ||
                                      errors[0]
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessContact.email && !errors[0]"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Do you have a website?
                                <span class="text-danger">*</span>
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="websiteURLdis"
                                  v-model="businessContact.websiteURLDisplay"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="websiteURLdis"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="businessContact.websiteURLDisplay">
                            <ValidationProvider
                              name="Website URL"
                              :rules="
                                businessContact.websiteURLDisplay
                                  ? 'required'
                                  : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    (errors.length &&
                                      !businessContact.websiteURL) ||
                                    errors[0],
                                  success:
                                    businessContact.websiteURL && !errors[0],
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessContact.websiteURL"
                                    class="form-control"
                                    name="websiteURL"
                                    id="website_URL"
                                    placeholder="Website URL*"
                                  />
                                  <label for="websiteURL" class="control-label">
                                    Website URL*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      (errors.length &&
                                        !businessContact.websiteURL) ||
                                      errors[0]
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="
                                      businessContact.websiteURL && !errors[0]
                                    "
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm &amp; Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Tell us about your needs -->
                <div
                  class="profile-collapse-list account-holder-list"
                  :class="[
                    { active: businessContact.businessContactIsSubmit },
                    account.accountStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.account
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="account.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="account.Icon"
                      />
                      Tell us about your needs
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="account.accountStatusColor"
                      >
                        {{ account.accountStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="account"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="businessContact.businessContactIsSubmit"
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(accountForm)"
                        id="account_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <div class="head">
                              <label>
                                What do you intend to use the account for?
                                <span class="text-danger">*</span>
                              </label>
                            </div>
                            <ValidationProvider
                              name="account use"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    (errors.length && !account.useOfAccount) ||
                                    (wordCounter < 3 && wordCounter > 0) ||
                                    wordCounter > 100,
                                  success:
                                    account.useOfAccount &&
                                    wordCounter > 2 &&
                                    wordCounter <= 100,
                                }"
                              >
                                <span class="float-label">
                                  <textarea
                                    type="text"
                                    v-model="account.useOfAccount"
                                    class="form-control"
                                    id="account_use"
                                    placeholder="Account Use*"
                                  />
                                  <label
                                    for="account_use"
                                    class="control-label"
                                  >
                                    Account Use*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      (errors.length &&
                                        !account.useOfAccount) ||
                                      (wordCounter < 3 && wordCounter > 0) ||
                                      wordCounter > 100
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="
                                      account.useOfAccount &&
                                      wordCounter > 2 &&
                                      wordCounter <= 100
                                    "
                                  ></i>
                                </span>
                              </div>
                              <label id="counter" class="pull-right">
                                {{ wordCounter }}/100 words
                              </label>
                            </ValidationProvider>
                          </li>
                          <li>
                            <label class="mb-1">
                              Which services are you interested in?
                            </label>
                            <div
                              class="d-flex justify-content-between align-items-stretch mb-4 mt-1 services-list"
                            >
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('bank-deposits')"
                                :class="{ active: account.activeBankDeposits }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 112 123" fill="none">
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M11.61 0H45.29C48.49 0 51.41 1.31 53.5 3.4C55.62 5.52 56.9 8.41 56.9 11.61V17.75C57.12 17.49 57.35 17.23 57.59 16.99C59.71 14.87 62.6 13.59 65.8 13.59H99.48C102.68 13.59 105.6 14.9 107.69 16.99C109.81 19.11 111.09 22 111.09 25.2V111.28C111.09 114.48 109.78 117.4 107.69 119.49C105.57 121.61 102.68 122.89 99.48 122.89H65.79C62.59 122.89 59.67 121.58 57.58 119.49C55.46 117.37 54.18 114.48 54.18 111.28V105.14C53.96 105.4 53.73 105.66 53.49 105.9C51.37 108.02 48.48 109.3 45.28 109.3H11.61C8.41 109.3 5.49 107.99 3.4 105.9C1.28 103.78 0 100.89 0 97.69V11.61C0 8.41 1.31 5.49 3.4 3.4C5.52 1.28 8.41 0 11.61 0ZM8.03 58.32L30.33 73.29L28.45 63.97C29.62 63.47 30.77 63.04 31.9 62.66C33.11 73.49 42.3 81.91 53.45 81.91C53.7 81.91 53.94 81.91 54.19 81.9V91.4H2.6V11.38H54.26V23.87C54.21 24.31 54.18 24.75 54.18 25.2V38.54C53.93 38.53 53.69 38.53 53.44 38.53C47.03 38.53 41.28 41.31 37.31 45.72C33.27 44.78 28.98 44.7 24.68 45.38L22.76 35.88L8.03 58.32ZM56.89 81.63C61.23 80.94 65.15 78.95 68.23 76.09C72.93 77.62 78.08 77.91 83.23 77.09L85.15 86.59L99.89 64.14L77.59 49.18L79.47 58.5C78 59.13 76.56 59.66 75.14 60.09C75.08 49.34 67.2 40.44 56.89 38.8V25.6H108.44V104.99H56.78V99.29C56.85 98.77 56.89 98.24 56.89 97.7V81.63ZM55.3 42.97L55.1 42.95L54.92 42.93H54.88C54.8 42.92 54.71 42.92 54.63 42.91H54.62H54.58H54.54H54.5C54.4 42.9 54.3 42.9 54.2 42.89C53.96 42.88 53.71 42.87 53.46 42.87C49.06 42.87 45.04 44.52 42 47.24C41.82 47.4 41.64 47.57 41.46 47.74L41.42 47.78C41.32 47.87 41.23 47.97 41.14 48.06L41.07 48.13C41.02 48.18 40.98 48.22 40.93 48.27C40.87 48.33 40.82 48.39 40.76 48.45L40.64 48.58C40.59 48.64 40.53 48.7 40.48 48.76L40.41 48.84C40.34 48.93 40.26 49.01 40.19 49.1L40.14 49.16C40.06 49.25 39.99 49.35 39.91 49.45L39.89 49.47C39.81 49.57 39.73 49.67 39.66 49.77L39.65 49.78C39.57 49.89 39.49 50 39.41 50.11V50.12C39.17 50.45 38.95 50.8 38.73 51.15L38.72 51.17C38.51 51.51 38.32 51.86 38.14 52.21L38.1 52.29C38.05 52.39 38 52.49 37.95 52.59L37.9 52.69C37.86 52.77 37.83 52.85 37.79 52.92L37.71 53.09C37.68 53.16 37.65 53.22 37.62 53.29L37.55 53.45C37.52 53.53 37.48 53.61 37.45 53.69C37.42 53.76 37.4 53.82 37.37 53.89L37.34 53.98C37.29 54.11 37.25 54.23 37.2 54.36L37.19 54.39C36.87 55.31 36.62 56.27 36.46 57.24V57.25C36.43 57.41 36.41 57.56 36.39 57.72V57.74C36.36 57.97 36.33 58.21 36.31 58.44L36.3 58.59C36.29 58.69 36.28 58.8 36.28 58.9L36.27 59.06C36.26 59.15 36.26 59.24 36.26 59.33C36.26 59.4 36.25 59.47 36.25 59.54V59.71C36.25 59.81 36.25 59.9 36.25 60V60.18C36.25 60.26 36.25 60.34 36.25 60.41C36.25 60.49 36.25 60.57 36.26 60.65L36.27 60.82C36.27 60.92 36.28 61.03 36.29 61.13L36.3 61.28L36.32 61.49C37.04 70.34 44.44 77.3 53.48 77.3C53.73 77.3 53.97 77.29 54.22 77.28C54.87 77.25 55.51 77.19 56.14 77.09L56.18 77.08L56.22 77.07L56.3 77.06L56.34 77.05L56.38 77.04L56.45 77.03H56.46L56.5 77.02L56.54 77.01L56.6 77H56.72H56.73L56.89 76.97H56.9C59.34 76.47 61.59 75.46 63.54 74.05C64.11 73.64 64.65 73.19 65.17 72.71C65.57 72.34 65.95 71.95 66.31 71.54C69.12 68.38 70.67 64.32 70.67 60.09C70.67 51.63 64.57 44.59 56.52 43.15L56.47 43.14C56.35 43.12 56.23 43.1 56.11 43.08L56.03 43.07C55.92 43.05 55.81 43.04 55.7 43.02L55.57 43C55.48 42.99 55.39 42.98 55.3 42.97ZM28.43 95.03C31.05 95.03 33.21 97.15 33.21 99.81C33.21 102.43 31.09 104.59 28.43 104.59C25.81 104.59 23.65 102.47 23.65 99.81C23.65 97.18 25.77 95.03 28.43 95.03ZM60.7 54.8L56.09 55.53C55.86 54.95 55.65 54.55 55.47 54.32C55.28 54.1 54.98 53.87 54.55 53.64V57.21C57.05 57.88 58.72 58.59 59.57 59.32C60.68 60.32 61.24 61.58 61.24 63.12C61.24 64.01 61.04 64.84 60.64 65.59C60.24 66.34 59.73 66.97 59.11 67.47C58.49 67.97 57.83 68.33 57.13 68.56C56.43 68.79 55.57 68.92 54.56 68.96V71.29H52.76V68.96C51.55 68.85 50.57 68.66 49.81 68.38C49.06 68.1 48.41 67.71 47.86 67.2C47.32 66.7 46.89 66.16 46.59 65.58C46.29 65 46.07 64.3 45.92 63.48L50.91 62.9C51.06 63.71 51.26 64.3 51.51 64.65C51.76 65.01 52.18 65.33 52.75 65.61V61.24C51.08 60.78 49.9 60.38 49.2 60.04C48.5 59.7 47.9 59.16 47.39 58.41C46.88 57.66 46.62 56.76 46.62 55.68C46.62 54.21 47.13 52.98 48.16 52C49.19 51.01 50.72 50.46 52.75 50.36V49.15H54.55V50.36C56.4 50.47 57.81 50.91 58.79 51.67C59.76 52.45 60.4 53.48 60.7 54.8ZM52.75 53.57C52.22 53.74 51.85 53.96 51.64 54.21C51.43 54.46 51.33 54.77 51.33 55.11C51.33 55.47 51.44 55.78 51.65 56.05C51.86 56.32 52.23 56.54 52.75 56.72V53.57ZM54.55 65.75C55.25 65.59 55.76 65.33 56.09 64.97C56.41 64.61 56.58 64.21 56.58 63.76C56.58 63.37 56.44 63.01 56.17 62.68C55.9 62.36 55.36 62.05 54.56 61.77V65.75H54.55Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">Bank Deposits</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('mobile-money')"
                                :class="{ active: account.activeMobileMoney }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 120 123" fill="none">
                                      <g clip-path="url(#clip0)">
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M2.71 63.08L35.96 37.56V58.93H83.14V37.49L116.68 63.08H2.71ZM75.05 0V54.17H44.05V0H75.05ZM68.66 27.1C68.66 32.14 64.58 36.22 59.54 36.22C54.5 36.22 50.42 32.14 50.42 27.1C50.42 22.06 54.5 17.98 59.54 17.98C64.59 17.97 68.66 22.05 68.66 27.1ZM70.33 9.96V44.15C67.81 44.15 65.75 46.21 65.75 48.73H53.5C53.5 46.21 51.44 44.15 48.92 44.15V9.96C51.44 9.96 53.5 7.9 53.5 5.38H65.75C65.75 7.91 67.81 9.96 70.33 9.96ZM0 116.45H8.8L10.08 112.83H13.81V77.72H6.19V69.31H112.91V77.72H105.29V112.83H109.02L110.3 116.45H119.1V122.88H0V116.45ZM39.62 112.84V77.72H27.85V112.83H31.58H39.62V112.84ZM65.43 112.84V77.72H53.67V112.83C57.59 112.84 61.51 112.84 65.43 112.84ZM91.24 112.84V77.72H79.48V112.83C83.4 112.84 87.32 112.84 91.24 112.84Z"
                                          fill="white"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">Mobile Money</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('airtime')"
                                :class="{ active: account.activeAirtime }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 92 123" fill="none">
                                      <g clip-path="url(#clip0)">
                                        <path
                                          d="M28.3 57.7613H64.77C67.18 57.7613 69.38 58.7513 70.97 60.3413C72.56 61.9313 73.55 64.1213 73.55 66.5413V99.9913C73.55 102.401 72.56 104.601 70.97 106.191C69.38 107.781 67.19 108.771 64.77 108.771H28.3C25.89 108.771 23.69 107.781 22.1 106.191C20.51 104.601 19.52 102.411 19.52 99.9913V66.5313C19.52 64.1113 20.51 61.9213 22.1 60.3313C23.69 58.7513 25.89 57.7613 28.3 57.7613ZM9.56 -3.98872H52.64C54.28 -3.98872 54.44 -3.98872 54.6 -3.98872C56.85 -4.01872 57.97 -4.02872 59.3 -3.47872C60.64 -2.91872 61.43 -2.10872 63.02 -0.468719C63.41 -0.058719 63.87 0.401281 64.37 0.911281C68.51 5.07128 72.31 9.00128 76.12 12.9213C79.82 16.7413 83.52 20.5613 87.48 24.5413C88.18 25.2413 88.79 25.8313 89.3 26.3213C90.78 27.7413 91.55 28.4813 92.12 29.7813C92.73 31.1813 92.72 32.4013 92.7 34.9713C92.7 35.2313 92.7 34.3313 92.7 36.6313V110.321C92.7 112.681 91.74 114.821 90.19 116.371C88.64 117.921 86.5 118.881 84.14 118.881H9.56C7.2 118.881 5.06 117.921 3.51 116.371C1.96 114.811 1 112.661 1 110.311V4.57128C1 2.21128 1.96 0.071281 3.51 -1.47872C5.06 -3.02872 7.21 -3.98872 9.56 -3.98872ZM52.64 1.89128H9.56C8.82 1.89128 8.15 2.19128 7.67 2.68128C7.18 3.16128 6.88 3.84128 6.88 4.57128V110.311C6.88 111.051 7.18 111.721 7.67 112.201C8.16 112.691 8.83 112.991 9.56 112.991H84.13C84.86 112.991 85.54 112.691 86.02 112.201C86.51 111.711 86.81 111.041 86.81 110.311V36.6113C86.81 35.5513 86.82 36.1813 86.83 34.9313C86.84 33.2013 86.85 32.3813 86.73 32.1113C86.64 31.8913 86.15 31.4313 85.22 30.5413C84.71 30.0513 84.09 29.4513 83.31 28.6713C79.3 24.6313 75.6 20.8213 71.91 17.0013C68.1 13.0713 64.3 9.14128 60.21 5.03128C59.65 4.47128 59.2 4.01128 58.82 3.61128C57.8 2.56128 57.29 2.03128 57.05 1.94128C56.81 1.84128 56.1 1.85128 54.67 1.87128C53.69 1.87128 52.74 1.89128 52.64 1.89128ZM56.45 62.1713V62.1813V74.2813H69.13V66.5313C69.13 65.3313 68.64 64.2413 67.85 63.4513C67.06 62.6613 65.97 62.1713 64.77 62.1713H56.45ZM69.14 78.8713H56.45V87.1413H69.13V78.8713H69.14ZM69.14 91.7213H56.45V104.351H64.77C65.97 104.351 67.06 103.861 67.85 103.071C68.64 102.281 69.13 101.191 69.13 99.9913V91.7213H69.14ZM52.04 104.351V90.0813C51.98 89.8713 51.95 89.6613 51.95 89.4313C51.95 89.2013 51.98 88.9913 52.04 88.7813V77.2313C51.98 77.0213 51.95 76.8113 51.95 76.5813C51.95 76.3513 51.98 76.1413 52.04 75.9313V62.1913V62.1813H28.3C27.1 62.1813 26.01 62.6713 25.22 63.4613C24.43 64.2513 23.94 65.3413 23.94 66.5413V74.3113H38.33C39.55 74.3113 40.54 75.3013 40.54 76.5213V88.5913C40.58 88.7613 40.61 88.9513 40.61 89.1413C40.61 89.3313 40.59 89.5113 40.54 89.6913V104.361H52.04V104.351ZM23.94 78.7113V86.8413H36.12V78.7113H23.94ZM23.94 91.4313V99.9913C23.94 101.191 24.43 102.281 25.22 103.071C26.01 103.861 27.1 104.351 28.3 104.351H36.12V91.4313H23.94Z"
                                          fill="white"
                                        />
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M45.5 6C50.1479 6 54.6913 7.37825 58.5559 9.96046C62.4205 12.5427 65.4325 16.2129 67.2112 20.5069C68.9898 24.801 69.4552 29.5261 68.5485 34.0846C67.6417 38.6432 65.4035 42.8305 62.117 46.117C58.8305 49.4035 54.6432 51.6417 50.0846 52.5485C45.5261 53.4552 40.801 52.9898 36.5069 51.2112C32.2129 49.4325 28.5427 46.4205 25.9605 42.5559C23.3783 38.6913 22 34.1479 22 29.5C22 23.2674 24.4759 17.2901 28.883 12.883C33.2901 8.47589 39.2674 6 45.5 6ZM48.9424 25.2544C48.923 24.9079 48.8296 24.5696 48.6687 24.2622C48.5077 23.9548 48.2828 23.6853 48.0091 23.472C47.7494 23.2753 47.4566 23.1263 47.1447 23.0321L47.0873 27.4499L47.6343 27.5723C48.5919 27.7721 49.5245 28.0774 50.415 28.4826C51.1597 28.8262 51.8452 29.2858 52.446 29.8442C52.9852 30.352 53.4103 30.9687 53.6929 31.6534C53.9828 32.3838 54.1321 33.1625 54.1327 33.9483C54.152 35.1726 53.7971 36.3736 53.1153 37.3907C52.3896 38.3933 51.3855 39.1607 50.2275 39.5977C49.1707 40.0097 48.0554 40.2524 46.9229 40.3167L46.8961 42.4663H44.211L44.2378 40.2976C43.1492 40.2104 42.0794 39.963 41.0632 39.5632C39.8124 39.0918 38.7372 38.2464 37.9841 37.1421C37.2089 35.9122 36.8162 34.4798 36.8558 33.0265H41.7708C41.7859 33.6352 41.9743 34.227 42.3139 34.7324C42.6515 35.2007 43.1179 35.5608 43.6564 35.769C43.8634 35.8549 44.077 35.924 44.2952 35.9755L44.3525 31.2862L43.3198 31.0491C41.7236 30.7411 40.2306 30.036 38.9786 28.9989C38.4497 28.5174 38.0341 27.9246 37.7617 27.2633C37.4892 26.6019 37.3666 25.8884 37.4028 25.1741C37.3753 23.9424 37.747 22.7348 38.4622 21.7317C39.2206 20.7135 40.2411 19.9203 41.415 19.4368C42.4005 19.0187 43.4464 18.7604 44.5132 18.6718L44.54 16.5337H47.2441L47.2174 18.7024C48.1798 18.8105 49.1193 19.0686 50.0019 19.4674C51.1454 19.9645 52.1253 20.7746 52.8285 21.8044C53.5102 22.8377 53.8684 24.0509 53.8573 25.2888L48.9424 25.2544ZM44.4635 22.9595C44.3228 22.9913 44.1848 23.0335 44.0504 23.0857C43.6508 23.2237 43.2991 23.4732 43.0368 23.8048C42.8181 24.1037 42.6978 24.4633 42.6925 24.8337C42.6747 25.1283 42.7424 25.4219 42.8876 25.679C43.0453 25.9346 43.2584 26.1515 43.5111 26.3139C43.7868 26.4965 44.0834 26.6455 44.3946 26.7576L44.4443 22.9671L44.4635 22.9595ZM46.9917 35.987C47.1364 35.9533 47.2784 35.9086 47.4163 35.8531C47.8538 35.7053 48.2426 35.4408 48.5408 35.0881C48.8 34.7618 48.9415 34.3575 48.9424 33.9407C48.9437 33.5627 48.8078 33.1971 48.5599 32.9118C48.2547 32.5723 47.8732 32.3101 47.4469 32.1468C47.3206 32.0933 47.1829 32.0397 47.0376 31.9862L46.9841 35.9717L46.9917 35.987ZM45.5 10.0085C49.3581 10.0085 53.1295 11.1525 56.3374 13.296C59.5453 15.4394 62.0455 18.4859 63.522 22.0504C64.9984 25.6148 65.3847 29.5369 64.632 33.3209C63.8793 37.1049 62.0215 40.5806 59.2934 43.3087C56.5653 46.0368 53.0896 47.8946 49.3056 48.6473C45.5216 49.4 41.5995 49.0137 38.0351 47.5373C34.4707 46.0608 31.4241 43.5606 29.2807 40.3527C27.1372 37.1448 25.9932 33.3734 25.9932 29.5153C25.9932 24.3418 28.0483 19.3801 31.7066 15.7219C35.3648 12.0636 40.3265 10.0085 45.5 10.0085Z"
                                          fill="white"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">Airtime</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('sms')"
                                :class="{ active: account.activeSms }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 123 123" fill="none">
                                      <g clip-path="url(#clip0)">
                                        <path
                                          d="M31.23 113.89L30 115.11C29.2917 115.868 28.3727 116.398 27.3613 116.629C26.3498 116.861 25.2921 116.785 24.3242 116.411C23.3563 116.037 22.5225 115.381 21.9301 114.529C21.3377 113.677 21.0138 112.668 21 111.63V99.45H19.39C18.202 99.4503 17.0258 99.2154 15.9291 98.7588C14.8323 98.3023 13.8368 97.6332 13 96.79C12.2476 96.0313 11.6319 95.1483 11.18 94.18H10.74C7.89412 94.1774 5.16541 93.0463 3.15212 91.0349C1.13884 89.0235 0.00529344 86.2959 0 83.45L0 10.73C0.00968543 8.07505 1.00791 5.51889 2.8 3.56L3.16 3.16C5.16459 1.1447 7.88751 0.00804983 10.73 0L105.14 0C107.646 0.0138233 110.07 0.89808 111.996 2.5015C113.922 4.10491 115.232 6.32784 115.7 8.79C117.408 9.16794 118.972 10.0247 120.21 11.26C121.054 12.0989 121.724 13.0959 122.182 14.1941C122.64 15.2923 122.878 16.4701 122.88 17.66V90.38C122.877 92.7847 121.921 95.0902 120.221 96.7905C118.52 98.4909 116.215 99.4474 113.81 99.45H59.81L37.39 120.93C36.9101 121.458 36.2817 121.829 35.5873 121.994C34.8929 122.159 34.1649 122.11 33.4988 121.853C32.8328 121.597 32.2597 121.145 31.8548 120.558C31.4499 119.97 31.2321 119.274 31.23 118.56V113.89ZM27.94 60.37C27.035 60.3218 26.1829 59.9284 25.5593 59.2708C24.9357 58.6131 24.5881 57.7413 24.5881 56.835C24.5881 55.9287 24.9357 55.0569 25.5593 54.3992C26.1829 53.7416 27.035 53.3482 27.94 53.3H76.87C77.35 53.2745 77.8303 53.347 78.2814 53.5131C78.7325 53.6792 79.145 53.9354 79.4938 54.2662C79.8427 54.597 80.1205 54.9953 80.3103 55.437C80.5002 55.8786 80.5981 56.3543 80.5981 56.835C80.5981 57.3157 80.5002 57.7914 80.3103 58.233C80.1205 58.6747 79.8427 59.073 79.4938 59.4038C79.145 59.7346 78.7325 59.9908 78.2814 60.1569C77.8303 60.323 77.35 60.3955 76.87 60.37H27.94ZM27.94 37.37C27.035 37.3218 26.1829 36.9284 25.5593 36.2708C24.9357 35.6131 24.5881 34.7413 24.5881 33.835C24.5881 32.9287 24.9357 32.0569 25.5593 31.3992C26.1829 30.7416 27.035 30.3482 27.94 30.3H87.94C88.845 30.3482 89.6971 30.7416 90.3207 31.3992C90.9443 32.0569 91.2919 32.9287 91.2919 33.835C91.2919 34.7413 90.9443 35.6131 90.3207 36.2708C89.6971 36.9284 88.845 37.3218 87.94 37.37H27.94ZM26.1 111.63L49.71 89H105.14C106.607 88.9974 108.013 88.4142 109.051 87.378C110.089 86.3418 110.675 84.9368 110.68 83.47V10.73C110.667 9.26567 110.079 7.86518 109.042 6.83064C108.006 5.7961 106.604 5.21044 105.14 5.2H10.73C9.26819 5.21561 7.87067 5.80324 6.83695 6.83695C5.80324 7.87067 5.21561 9.26819 5.2 10.73V83.45C5.20523 84.9169 5.7889 86.3225 6.82428 87.3616C7.85965 88.4007 9.26314 88.9895 10.73 89H26.1V111.65V111.63Z"
                                          fill="white"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">SMS</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('ussd')"
                                :class="{ active: account.activeUssd }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 123 98" fill="none">
                                      <g clip-path="url(#clip0)">
                                        <path
                                          d="M2.38 0H20.71V4.76H4.76V17.2H0V2.38C0 1.07 1.07 0 2.38 0ZM17.92 16.23H26.18V80.81H17.92V16.23ZM69.41 16.23H75.31V80.81H69.41V16.23ZM57.98 16.23H62.4V80.81H57.98V16.23ZM33.19 16.23H35.7V80.81H33.19V16.23ZM97.59 16.23H104.96V80.81H97.59V16.23ZM82.32 16.23H90.58V80.81H82.32V16.23ZM42.71 16.23H50.97V80.81H42.71V16.23ZM4.76 79.84V92.28H20.71V97.04H2.38C1.07 97.04 0 95.98 0 94.66V79.84H4.76ZM103.4 0H120.5C121.81 0 122.88 1.07 122.88 2.38V17.2H118.12V4.76H103.4V0ZM122.88 79.84V94.66C122.88 95.97 121.81 97.04 120.5 97.04H103.4V92.28H118.12V79.84H122.88Z"
                                          fill="white"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">USSD</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="
                                  ServiceActive('mobile-money-collections')
                                "
                                :class="{
                                  active: account.activeMobileMoneyCollections,
                                }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="-7 -11 84 123">
                                      <g>
                                        <path
                                          class="st0"
                                          d="M48,46.2c1-0.5,2.1-1,3.2-1.4c-1.3-5.3-4.3-10-8.6-13.4c-4.3-3.4-9.6-5.2-15-5.2c-3.8,0-7.6,0.9-11,2.6   c-3.4,1.7-6.3,4.2-8.6,7.3c-2.2,3.1-3.7,6.7-4.3,10.4c-0.6,3.8-0.3,7.6,0.9,11.2c1.2,3.6,3.2,6.9,5.9,9.6c2.7,2.7,6,4.7,9.6,5.9   c3.6,1.2,7.5,1.5,11.2,0.9c3.8-0.6,7.3-2,10.5-4.2c-1-2.2-1.2-4.7-0.5-7c0.2-0.6,0.4-1.2,0.7-1.8c-0.7-1.4-1.2-3-1.2-4.6   C40.8,51.7,43.9,48.3,48,46.2z M26.4,46.4c0.5,0.5,1.5,1.1,2.9,1.7c1.4,0.6,2.6,1.1,3.5,1.6c0.9,0.5,1.7,1.1,2.3,1.7   c0.6,0.6,1.1,1.3,1.4,2.1c0.3,0.8,0.5,1.7,0.5,2.8c0,2-0.6,3.6-1.9,4.9s-3,2-5.1,2.2v3.5h-2.8v-3.5c-2.4-0.3-4.3-1.1-5.6-2.5   c-1.3-1.5-2-3.4-2-5.8h5.1c0,1.4,0.3,2.5,1,3.2c0.7,0.7,1.6,1.1,2.9,1.1c1,0,1.8-0.3,2.4-0.8c0.6-0.6,0.9-1.3,0.9-2.2   c0-1-0.3-1.7-0.8-2.3c-0.5-0.6-1.4-1.1-2.7-1.6c-1.3-0.5-2.4-1-3.3-1.4c-0.9-0.5-1.7-1-2.4-1.6c-0.7-0.6-1.2-1.3-1.5-2.2   c-0.4-0.8-0.5-1.8-0.5-3c0-2,0.6-3.6,1.9-4.9c1.3-1.3,2.9-2,5-2.2v-3.8h2.8v3.8c2.1,0.3,3.7,1.2,4.9,2.6c1.2,1.4,1.8,3.3,1.8,5.6   h-5.1c0-1.4-0.3-2.5-0.9-3.1c-0.6-0.7-1.3-1.1-2.3-1.1c-1,0-1.7,0.3-2.2,0.8c-0.5,0.5-0.8,1.3-0.8,2.3   C25.7,45.1,25.9,45.8,26.4,46.4z"
                                        />
                                        <path
                                          class="st0"
                                          d="M58.4,88.3v5.2H-3.1v-90h61.5v39.8c0.9-0.1,1.9-0.2,2.9-0.2h1.1V2.3c0-1.7-0.3-3.5-1-5.1   c-0.7-1.6-1.6-3.1-2.9-4.3c-1.2-1.2-2.7-2.2-4.3-2.9c-1.6-0.7-3.3-1-5.1-1H6.3c-1.7,0-3.5,0.3-5.1,1c-1.6,0.7-3.1,1.6-4.3,2.9   C-4.3-5.9-5.3-4.4-6-2.8c-0.7,1.6-1,3.3-1,5.1v96.3c0,1.7,0.3,3.5,1,5.1c0.7,1.6,1.6,3.1,2.9,4.3c1.2,1.2,2.7,2.2,4.3,2.9   c1.6,0.7,3.3,1,5.1,1h42.8c1.7,0,3.5-0.3,5.1-1c1.6-0.7,3.1-1.6,4.3-2.9c1.2-1.2,2.2-2.7,2.9-4.3c0.7-1.6,1-3.3,1-5.1V88.4h-1.1   C60.3,88.4,59.4,88.4,58.4,88.3z"
                                        />
                                        <path
                                          class="st0"
                                          d="M61.3,78.3c-6.7,0-12.3-2.3-14.3-5.5c-0.4,0.7-0.6,1.5-0.6,2.3c0,4.3,6.7,7.8,14.9,7.8   c8.2,0,14.9-3.5,14.9-7.8c0-0.8-0.2-1.6-0.7-2.3C73.7,76,67.9,78.3,61.3,78.3z"
                                        />
                                        <polygon
                                          class="st0"
                                          points="75.6,63.7 75.6,63.7 75.6,63.7  "
                                        />
                                        <path
                                          class="st0"
                                          d="M61.3,69.2c-6.8,0-12.5-2.4-14.3-5.6c-0.4,0.7-0.6,1.5-0.6,2.3c0,4.3,6.7,7.8,14.9,7.8   c8.2,0,14.9-3.5,14.9-7.8c0-0.8-0.2-1.6-0.6-2.2C73.2,67.9,65.8,69.2,61.3,69.2z"
                                        />
                                        <path
                                          class="st0"
                                          d="M61.3,50.1c-6.8,0-12.3,3.3-12.3,7.4s5.5,7.4,12.3,7.4c6.8,0,12.3-3.3,12.3-7.4C73.6,53.4,68.1,50.1,61.3,50.1   L61.3,50.1z M64.4,57.3v1.5h-2.6v3h-1.6v-3h-2.6v-1.5h2.6v-2.8h1.6v2.8H64.4z"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">
                                  Mobile Money Collections
                                </h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('virtual-POS')"
                                :class="{ active: account.activevirtualPOS }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 120 123" fill="none">
                                      <svg viewBox="0 0 67.92 122.88">
                                        <g>
                                          <path
                                            d="M1.62,73.77c-0.56-2.09-0.96-3.65-1.23-5.76C0.12,65.93,0,63.41,0,59.44V41.76v-8.28c0-2.2,0.84-4.19,2.2-5.64 c1.14-1.22,2.64-2.05,4.3-2.28V4.64c0-1.28,0.52-2.44,1.36-3.28C8.7,0.52,9.86,0,11.14,0h45.51c1.29,0,2.46,0.53,3.31,1.38 c0.85,0.85,1.38,2.02,1.38,3.31v20.88c1.62,0.26,3.08,1.08,4.19,2.27c1.36,1.45,2.21,3.46,2.21,5.66v26.02v0 c0.31,3.75,0.21,6.77-0.12,9.36c-0.33,2.65-0.89,4.82-1.49,6.87c-2.95,10.04-2.77,18.89-2.58,28.78c0.05,2.71,0.11,5.5,0.11,7.99 c0,0.02,0,0.05,0,0.07c0.09,3.28-0.61,5.86-2.22,7.66c-1.63,1.82-4.09,2.73-7.47,2.62v0H13.27c-0.03,0-0.05,0-0.08,0 c-3.21,0.09-5.43-0.84-6.88-2.57c-1.45-1.72-2.03-4.13-2.02-7.02H4.29v-18.8c0-4.31-0.12-7.47-0.52-10.53 C3.38,80.89,2.71,77.85,1.62,73.77L1.62,73.77z M13.34,67.92h9.89v10.91h-9.89V67.92L13.34,67.92z M29.02,102.33h9.89v10.91h-9.89 V102.33L29.02,102.33z M13.34,102.33h9.89v10.91h-9.89V102.33L13.34,102.33z M44.7,85.12h9.89v28.07H44.7V85.12L44.7,85.12z M29.02,85.12h9.89v10.91h-9.89V85.12L29.02,85.12z M13.34,85.12h9.89v10.91h-9.89V85.12L13.34,85.12z M44.7,67.92h9.89v10.91H44.7 V67.92L44.7,67.92z M29.02,67.92h9.89v10.91h-9.89V67.92L29.02,67.92z M11.7,36.29h44.52c0.75,0,1.44,0.33,1.92,0.85 c0.05,0.05,0.1,0.11,0.14,0.17c0.37,0.47,0.6,1.07,0.6,1.71v19.63c0,0.72-0.29,1.38-0.74,1.88l0,0c-0.49,0.52-1.17,0.85-1.92,0.85 H11.7c-0.75,0-1.43-0.33-1.92-0.85c-0.46-0.49-0.75-1.16-0.75-1.88V39.01c0-0.72,0.29-1.39,0.75-1.88 C10.28,36.61,10.95,36.29,11.7,36.29L11.7,36.29z M55.36,39.82H12.57v18.02h42.79V39.82L55.36,39.82z M46.57,15.69 c-0.85,0-1.54-0.69-1.54-1.54c0-0.85,0.69-1.54,1.54-1.54h6.09c0.85,0,1.54,0.69,1.54,1.54c0,0.85-0.69,1.54-1.54,1.54H46.57 L46.57,15.69z M41.77,9.35c-0.85,0-1.54-0.69-1.54-1.54c0-0.85,0.69-1.54,1.54-1.54h10.89c0.85,0,1.54,0.69,1.54,1.54 c0,0.85-0.69,1.54-1.54,1.54H41.77L41.77,9.35z M13.82,10.98c0-1.84,1.49-3.33,3.33-3.33c0.84,0,1.61,0.31,2.19,0.83 c0.59-0.51,1.35-0.83,2.19-0.83c1.84,0,3.33,1.49,3.33,3.33c0,1.84-1.49,3.33-3.33,3.33c-0.84,0-1.61-0.31-2.19-0.82 C18.76,14,18,14.31,17.16,14.31C15.32,14.31,13.82,12.82,13.82,10.98L13.82,10.98z M9.23,19.15h49.38V4.69 c0-0.54-0.22-1.02-0.58-1.38c-0.35-0.35-0.84-0.58-1.38-0.58H11.14c-0.52,0-1,0.22-1.35,0.56C9.45,3.64,9.23,4.12,9.23,4.64V19.15 L9.23,19.15z M58.61,21.49H9.23v3.64h49.38V21.49L58.61,21.49z M3.29,67.6c0.24,1.86,0.62,3.34,1.15,5.32 c1.13,4.19,1.82,7.35,2.24,10.61c0.42,3.26,0.55,6.53,0.55,10.95v18.8H7.22v0.01c-0.01,2.14,0.36,3.85,1.27,4.94 c0.87,1.04,2.36,1.6,4.62,1.54c0.05-0.01,0.11-0.01,0.16-0.01h40.69v0.01l0.05,0c2.52,0.08,4.26-0.49,5.31-1.66 c1.04-1.15,1.49-2.98,1.42-5.41c-0.01-0.06-0.01-0.12-0.01-0.18c0-3-0.05-5.5-0.1-7.93c-0.2-10.16-0.38-19.26,2.7-29.77 c0.57-1.93,1.09-3.95,1.39-6.34c0.3-2.39,0.39-5.18,0.1-8.68c-0.02-0.09-0.02-0.18-0.02-0.28V33.5c0-1.35-0.52-2.58-1.35-3.47 c-0.83-0.88-1.97-1.43-3.23-1.43h-2.41H29.37H7.49c-1.25,0-2.39,0.55-3.22,1.43c-0.83,0.88-1.34,2.1-1.34,3.45v8.28v17.68 C2.93,63.31,3.04,65.7,3.29,67.6L3.29,67.6z"
                                          />
                                        </g>
                                      </svg>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">Virtual POS</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('qr-code-payments')"
                                :class="{ active: account.activeQRCode }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 122.88 122.7">
                                      <g>
                                        <path
                                          class="st0"
                                          d="M0.18,0h44.63v44.45H0.18V0L0.18,0z M111.5,111.5h11.38v11.2H111.5V111.5L111.5,111.5z M89.63,111.48h11.38 v10.67H89.63h-0.01H78.25v-21.82h11.02V89.27h11.21V67.22h11.38v10.84h10.84v11.2h-10.84v11.2h-11.21h-0.17H89.63V111.48 L89.63,111.48z M55.84,89.09h11.02v-11.2H56.2v-11.2h10.66v-11.2H56.02v11.2H44.63v-11.2h11.2V22.23h11.38v33.25h11.02v11.2h10.84 v-11.2h11.38v11.2H89.63v11.2H78.25v22.05H67.22v22.23H55.84V89.09L55.84,89.09z M111.31,55.48h11.38v11.2h-11.38V55.48 L111.31,55.48z M22.41,55.48h11.38v11.2H22.41V55.48L22.41,55.48z M0.18,55.48h11.38v11.2H0.18V55.48L0.18,55.48z M55.84,0h11.38 v11.2H55.84V0L55.84,0z M0,78.06h44.63v44.45H0V78.06L0,78.06z M10.84,88.86h22.95v22.86H10.84V88.86L10.84,88.86z M78.06,0h44.63 v44.45H78.06V0L78.06,0z M88.91,10.8h22.95v22.86H88.91V10.8L88.91,10.8z M11.02,10.8h22.95v22.86H11.02V10.8L11.02,10.8z"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">QR Code Payments</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('internet-data-bundle')"
                                :class="{ active: account.activeInternetData }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 122.88 115.33">
                                      <g>
                                        <path
                                          d="M76.98,97.89c-3.62,4.01-7.79,7.99-12.51,11.94c1.28-0.17,2.56-0.38,3.81-0.62c3.42-0.69,6.71-1.7,9.89-3.08 c0.82-0.35,1.62-0.72,2.41-1.1c0.59,0.76,1.25,1.42,1.96,1.98c0.77,0.61,1.59,1.09,2.45,1.45c-1.58,0.85-3.2,1.62-4.86,2.34 c-3.53,1.52-7.16,2.63-10.9,3.39c-3.74,0.76-7.61,1.14-11.59,1.14c-3.98,0-7.82-0.38-11.59-1.14c-3.7-0.73-7.26-1.83-10.76-3.32 c-0.03,0-0.1-0.03-0.14-0.07c-3.46-1.49-6.75-3.29-9.82-5.33c-3.08-2.04-5.92-4.39-8.51-6.99c-2.63-2.59-4.95-5.43-6.99-8.51 c-2.08-3.08-3.84-6.37-5.33-9.82c-1.52-3.53-2.63-7.16-3.39-10.9C0.38,65.52,0,61.64,0,57.66c0-3.98,0.38-7.82,1.14-11.59 c0.73-3.7,1.83-7.26,3.32-10.76c0-0.03,0.03-0.1,0.07-0.14c1.49-3.49,3.29-6.75,5.33-9.82c2.04-3.08,4.39-5.92,6.99-8.51 c2.59-2.63,5.43-4.95,8.51-6.99c3.08-2.08,6.36-3.84,9.82-5.33c3.53-1.52,7.16-2.63,10.9-3.39C49.81,0.38,53.69,0,57.66,0 c3.98,0,7.82,0.38,11.59,1.14c3.7,0.73,7.26,1.83,10.76,3.32c0.03,0,0.1,0.03,0.14,0.07c3.46,1.49,6.75,3.29,9.82,5.33 c3.08,2.04,5.92,4.39,8.51,6.99c2.63,2.59,4.95,5.43,6.99,8.51c2.08,3.08,3.84,6.37,5.33,9.82c1.52,3.53,2.63,7.16,3.39,10.9 c0.43,2.12,0.74,4.28,0.93,6.48l-5.23-1.39c-0.16-1.38-0.37-2.74-0.64-4.09c-0.69-3.42-1.7-6.71-3.08-9.89 c-0.86-2.04-1.83-3.98-2.91-5.85l0,0H86.38c3,5.13,5.16,10.23,6.47,15.32l-5.68-1.51c-1.48-4.56-3.71-9.16-6.71-13.81H60.19v9.39 c-0.36,0.21-0.72,0.46-1.07,0.74l0,0c-0.28,0.22-0.55,0.46-0.8,0.71c-0.34,0.35-0.66,0.72-0.93,1.12 c-0.44,0.64-0.79,1.35-1.06,2.11c-0.27,0.77-0.43,1.54-0.49,2.29c-0.05,0.64-0.03,1.3,0.07,1.95c0.08,0.54,0.2,1.07,0.38,1.59 l0.05,0.14c0.04,0.11,0.08,0.22,0.12,0.32c0.06,0.17,0.11,0.27,0.13,0.32l0.02-0.01l3.63,8.17h-0.06v23.8h10.62l2.24,5.05H60.19 v17.78c5.65-4.64,10.5-9.32,14.54-14.01L76.98,97.89L76.98,97.89z M115.14,97.97c-0.34,0.34-0.74,0.6-1.16,0.79 c-0.44,0.2-0.91,0.32-1.38,0.36c-0.51,0.04-1.03-0.01-1.53-0.17c-0.48-0.15-0.94-0.4-1.35-0.74l-11.09-9.41l-3.81,9.35 c-0.32,0.78-0.7,1.5-1.13,2.15c-0.44,0.66-0.93,1.23-1.44,1.68c-0.41,0.36-0.86,0.67-1.33,0.9c-0.47,0.23-0.95,0.38-1.45,0.45 c-0.58,0.08-1.16,0.04-1.72-0.12c-0.54-0.16-1.06-0.42-1.56-0.81c-0.4-0.31-0.77-0.71-1.12-1.19c-0.32-0.44-0.61-0.96-0.88-1.56 c-7.22-16.27-15.83-33.78-22.27-50.16c-0.08-0.22-0.14-0.44-0.17-0.67c-0.03-0.23-0.04-0.46-0.02-0.69 c0.02-0.27,0.08-0.53,0.17-0.79c0.09-0.25,0.21-0.5,0.36-0.72c0.08-0.11,0.16-0.22,0.26-0.31c0.08-0.08,0.17-0.16,0.27-0.23 c0.18-0.14,0.37-0.26,0.57-0.36l0.05-0.02c0.19-0.09,0.39-0.16,0.58-0.2l0.09-0.02c0.18-0.04,0.36-0.06,0.54-0.07 c0.21-0.01,0.41,0.01,0.61,0.04c0.07,0.01,0.14,0.02,0.21,0.03c17.64,4.38,35.38,9.38,52.98,14.05c0.63,0.17,1.19,0.38,1.68,0.62 c0.53,0.27,0.98,0.57,1.35,0.91c0.46,0.42,0.81,0.9,1.05,1.41c0.25,0.53,0.38,1.1,0.39,1.69v0.01c0.01,0.5-0.06,1-0.21,1.5 c-0.15,0.5-0.38,0.98-0.68,1.45c-0.37,0.58-0.85,1.16-1.43,1.69c-0.56,0.52-1.22,1.01-1.95,1.46c-2.89,1.7-5.77,3.5-8.64,5.24 l11.05,9.47c0.4,0.35,0.72,0.76,0.94,1.21l0.03,0.08c0.21,0.45,0.34,0.92,0.38,1.41c0.04,0.49-0.01,1-0.16,1.5 c-0.14,0.47-0.37,0.93-0.69,1.34C119.84,92.6,117.01,96.24,115.14,97.97L115.14,97.97z M112.24,94.34l5.35-6.28l-13-11.14 l-0.07-0.07c-0.06-0.06-0.13-0.13-0.18-0.19c-0.08-0.09-0.15-0.19-0.21-0.3c-0.33-0.54-0.4-1.16-0.26-1.73 c0.14-0.57,0.5-1.09,1.04-1.41c3.76-2.07,7.64-4.66,11.35-6.89c0.43-0.26,0.81-0.55,1.13-0.84c0.3-0.28,0.55-0.56,0.72-0.83 c0.07-0.11,0.12-0.2,0.15-0.29c-0.08-0.06-0.17-0.11-0.3-0.17c-0.19-0.09-0.44-0.17-0.73-0.25L67.51,50.77L88.39,97.8 c0.12,0.26,0.24,0.49,0.37,0.68l0.03,0.05c0.07,0.09,0.13,0.17,0.18,0.22c0.08-0.04,0.16-0.11,0.26-0.2 c0.24-0.21,0.48-0.5,0.7-0.84c0.24-0.36,0.46-0.79,0.65-1.27l5-12.28l0.05-0.1c0.04-0.08,0.08-0.16,0.12-0.23l0.03-0.05 c0.05-0.08,0.11-0.16,0.18-0.24c0.41-0.48,0.98-0.76,1.56-0.8c0.58-0.05,1.18,0.13,1.67,0.54L112.24,94.34L112.24,94.34z M50.89,109.83c-8.16-6.85-14.7-13.77-19.54-20.79H15.39c1.52,2.08,3.22,4.01,5.05,5.85c2.39,2.39,4.95,4.5,7.75,6.36 c2.77,1.87,5.78,3.49,9.03,4.88c0.03,0.03,0.07,0.03,0.1,0.07c3.15,1.31,6.4,2.35,9.79,3.01c1.25,0.24,2.53,0.45,3.8,0.62H50.89 L50.89,109.83z M12.07,83.99h16.05c-4.46-7.82-6.88-15.77-7.16-23.8H5.12c0.14,2.77,0.45,5.43,0.97,8.06 c0.69,3.42,1.69,6.71,3.08,9.89C10.03,80.18,11,82.12,12.07,83.99L12.07,83.99z M5.12,55.14h15.95c0.59-7.89,3.22-15.81,7.89-23.8 H12.07c-1.07,1.87-2.04,3.8-2.91,5.85c-0.03,0.03-0.03,0.07-0.07,0.1c-1.31,3.15-2.35,6.4-3.01,9.79 C5.57,49.71,5.22,52.37,5.12,55.14L5.12,55.14z M15.36,26.29h16.85c4.81-6.92,11.14-13.87,19.03-20.86 c-1.42,0.17-2.8,0.38-4.15,0.66c-3.42,0.69-6.71,1.7-9.89,3.08c-3.22,1.38-6.23,3.01-9.03,4.88c-2.8,1.87-5.36,3.98-7.75,6.36 c-1.83,1.83-3.53,3.77-5.05,5.85L15.36,26.29L15.36,26.29z M64.1,5.43c7.92,6.99,14.25,13.94,19.03,20.86h16.85 c-1.52-2.08-3.22-4.01-5.05-5.85c-2.39-2.39-4.95-4.5-7.75-6.37c-2.77-1.87-5.78-3.49-9.03-4.88c-0.03-0.03-0.07-0.03-0.1-0.07 c-3.15-1.31-6.4-2.35-9.79-3.01c-1.38-0.28-2.77-0.48-4.15-0.66V5.43L64.1,5.43z M60.19,8.72v17.57h16.74 C72.54,20.48,66.97,14.63,60.19,8.72L60.19,8.72z M55.14,106.82V89.04H37.53C42.06,94.99,47.94,100.94,55.14,106.82L55.14,106.82z M55.14,83.99v-23.8H26.01c0.31,7.99,3.01,15.91,7.99,23.8H55.14L55.14,83.99z M55.14,55.14v-23.8H34.87 c-5.19,8.06-8.09,15.98-8.75,23.8H55.14L55.14,55.14z M55.14,26.29V8.72c-6.78,5.92-12.35,11.76-16.74,17.57H55.14L55.14,26.29z"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">Internet Data Bundle</h6>
                              </div>
                              <div
                                class="services-box d-flex flex-column flex-grow-1 align-items-center border p-3 text-center"
                                @click="ServiceActive('bill-payments')"
                                :class="{ active: account.activeBill }"
                              >
                                <div class="btn btn-primary btn-lg mb-1">
                                  <div class="svg-box wh-25 ml-auto mr-auto">
                                    <svg viewBox="0 0 97.92 122.88">
                                      <g>
                                        <path
                                          d="M68.17,0.66C67.73,0.26,67.11,0,66.5,0c-0.13,0-0.26,0-0.4,0.04H5.54c-1.49,0-2.9,0.62-3.91,1.63C0.62,2.68,0,4.04,0,5.58 v111.76c0,1.54,0.62,2.9,1.63,3.91c1.01,1.01,2.37,1.63,3.91,1.63c28.22,0,58.68,0,86.76,0c1.54,0,2.9-0.62,3.91-1.63 c1.01-1.01,1.63-2.37,1.63-3.91V32.3c0.04-0.22,0.09-0.4,0.09-0.62c0-0.75-0.35-1.41-0.84-1.89L68.47,0.84 c-0.09-0.09-0.13-0.13-0.22-0.18H68.17L68.17,0.66z M20.53,19.68c-1.36,0-2.5,1.1-2.5,2.51c0,1.36,1.1,2.5,2.5,2.5h17.15 c1.36,0,2.51-1.1,2.51-2.5c0-1.36-1.1-2.51-2.51-2.51H20.53L20.53,19.68z M39.13,83.35h-8.88v-1.47c0-1.57-0.11-2.59-0.31-3.07 c-0.2-0.49-0.64-0.73-1.31-0.73c-0.54,0-0.95,0.21-1.22,0.62C27.14,79.13,27,79.75,27,80.59c0,1.39,0.28,2.37,0.83,2.92 c0.54,0.56,2.14,1.64,4.79,3.25c2.25,1.37,3.79,2.41,4.61,3.13c0.82,0.73,1.51,1.75,2.07,3.08c0.56,1.33,0.85,2.98,0.85,4.96 c0,3.16-0.76,5.65-2.28,7.45c-1.52,1.8-3.82,2.91-6.86,3.34v3.33h-4.1v-3.42c-2.37-0.23-4.45-1.15-6.22-2.74 c-1.77-1.58-2.66-4.36-2.66-8.32v-1.74h8.88v2.17c0,2.39,0.09,3.87,0.28,4.45c0.18,0.58,0.62,0.86,1.32,0.86 c0.6,0,1.05-0.2,1.34-0.6c0.29-0.41,0.44-1.01,0.44-1.8c0-1.99-0.14-3.42-0.42-4.27c-0.28-0.86-1.22-1.8-2.85-2.8 c-2.71-1.7-4.55-2.95-5.53-3.75c-0.97-0.8-1.82-1.92-2.52-3.38c-0.71-1.45-1.07-3.09-1.07-4.92c0-2.65,0.75-4.73,2.25-6.24 c1.5-1.51,3.76-2.44,6.76-2.79v-2.84h4.1v2.84c2.74,0.35,4.79,1.27,6.16,2.76c1.36,1.49,2.04,3.55,2.04,6.17 C39.22,82.05,39.19,82.61,39.13,83.35L39.13,83.35z M63.99,5.01v21.67c0,2.07,0.84,3.96,2.2,5.32c1.36,1.36,3.25,2.2,5.32,2.2 h21.27v83.15c0,0.13-0.04,0.31-0.18,0.4c-0.09,0.09-0.22,0.18-0.4,0.18c-22.34,0-64.98,0-86.71,0c-0.13,0-0.31-0.04-0.4-0.18 c-0.09-0.09-0.18-0.26-0.18-0.4V5.58c0-0.18,0.04-0.31,0.18-0.4c0.09-0.09,0.22-0.18,0.4-0.18h58.45H63.99L63.99,5.01z M68.96,26.68V8.53l20.44,20.7H71.51c-0.7,0-1.32-0.31-1.8-0.75C69.26,28.04,68.96,27.38,68.96,26.68L68.96,26.68z M20.52,36.96 c-1.36,0-2.5,1.1-2.5,2.51c0,1.36,1.1,2.51,2.5,2.51h43.86c1.36,0,2.51-1.1,2.51-2.51c0-1.36-1.1-2.51-2.51-2.51H20.52L20.52,36.96 z M49,70.36c-1.36,0-2.5,1.1-2.5,2.51c0,1.36,1.1,2.51,2.5,2.51h28.22c1.36,0,2.51-1.1,2.51-2.51c0-1.36-1.1-2.51-2.51-2.51H49 L49,70.36z M20.52,53.66c-1.36,0-2.5,1.1-2.5,2.51c0,1.36,1.1,2.51,2.5,2.51h56.69c1.36,0,2.51-1.1,2.51-2.51 c0-1.36-1.1-2.51-2.51-2.51H20.52L20.52,53.66z"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <h6 class="mb-0 mt-3">Bill Payments</h6>
                              </div>
                            </div>
                          </li>
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm &amp; Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Controllers of your Business -->
                <div
                  class="profile-collapse-list business-controllers"
                  :class="[
                    {
                      active:
                        account.accountIsSubmit &&
                        businessInfo.businessTypeTitle === 'Business',
                    },
                    controllersStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.controllers
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="controllersIcon"
                        class="img-fluid"
                        alt=""
                        v-if="controllersIcon"
                      />
                      Controllers of your Business
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="controllersStatusColor"
                      >
                        {{ controllersStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="controllers"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="
                      account.accountIsSubmit &&
                      businessInfo.businessTypeTitle === 'Business'
                    "
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(controllersForm)"
                        id="controllers_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <!-- Directors -->
                          <li>
                            <h6 class="mb-3 font-15">
                              <i class="fa fa-level-up fa-rotate-90"></i>
                              <strong>Directors</strong>
                            </h6>
                          </li>
                          <li>
                            <div
                              class="form-repeat"
                              v-for="(director, index) in directors"
                              :key="index"
                            >
                              <ul class="list-unstyled mb-0">
                                <li
                                  class="d-flex justify-content-between align-items-center mb-3"
                                  v-if="index !== 0"
                                >
                                  <h6 class="mb-0 font-15">
                                    <i class="fa fa-level-up fa-rotate-90"></i>
                                    <strong>Director</strong>
                                  </h6>
                                  <button
                                    class="btn btn-danger"
                                    @click="removeDirector(index)"
                                  >
                                    <i class="fa fa-times"></i>
                                  </button>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'firstName_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.first_name,
                                            success: director.first_name,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.first_name"
                                              class="form-control"
                                              :id="'firstName_' + index"
                                              placeholder="First Name*"
                                            />
                                            <label
                                              :for="'firstName_' + index"
                                              class="control-label"
                                            >
                                              First Name*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.first_name
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.first_name"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'middleName_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.middle_name,
                                            success: director.middle_name,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.middle_name"
                                              class="form-control"
                                              :id="'middleName_' + index"
                                              placeholder="Middle Name*"
                                            />
                                            <label
                                              :for="'middleName_' + index"
                                              class="control-label"
                                            >
                                              Middle Name*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.middle_name
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.middle_name"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'lastName_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.last_name,
                                            success: director.last_name,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.last_name"
                                              class="form-control"
                                              :id="'lastName_' + index"
                                              placeholder="Last Name*"
                                            />
                                            <label
                                              :for="'lastName_' + index"
                                              class="control-label"
                                            >
                                              Last Name*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.last_name
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.last_name"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <div class="head">
                                        <label class="mb-1">
                                          Date of Appointment
                                        </label>
                                      </div>
                                      <ValidationProvider
                                        name="director_appointment"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.date_of_appointment,
                                            success:
                                              director.date_of_appointment,
                                          }"
                                        >
                                          <span class="float-label">
                                            <dropdown-datepicker
                                              :daySuffixes="false"
                                              month-format="short"
                                              display-format="dmy"
                                              v-model="
                                                director.date_of_appointment
                                              "
                                            ></dropdown-datepicker>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.date_of_appointment
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="
                                                director.date_of_appointment
                                              "
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <div class="head d-none d-md-block">
                                        <label class="mb-1">&nbsp;</label>
                                      </div>
                                      <ValidationProvider
                                        :name="'occupation_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.occupation,
                                            success: director.occupation,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.occupation"
                                              class="form-control"
                                              :id="'occupation_' + index"
                                              placeholder="Occupation*"
                                            />
                                            <label
                                              :for="'occupation_' + index"
                                              class="control-label"
                                            >
                                              Occupation*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.occupation
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.occupation"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'nationality_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="country-dropdown">
                                          <div
                                            class="form-group form-select multiselect-grp"
                                            :class="{
                                              errors: errors[0],
                                              success:
                                                director.nationality &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <label for="Country">
                                                Nationality*
                                              </label>
                                              <multiselect
                                                placeholder=""
                                                v-model="director.nationality"
                                                :show-labels="false"
                                                :options="nationality_countrys"
                                                :searchable="false"
                                                label="name"
                                                track-by="name"
                                              >
                                                <template
                                                  slot="option"
                                                  slot-scope="props"
                                                >
                                                  <span
                                                    :class="
                                                      props.option.flagClass
                                                    "
                                                  ></span>
                                                  <div class="option__desc">
                                                    <span class="option__title">
                                                      {{ props.option.name }}
                                                    </span>
                                                  </div>
                                                </template>
                                              </multiselect>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length && errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  director.nationality &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'residenceCountry_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="country-dropdown">
                                          <div
                                            class="form-group form-select multiselect-grp"
                                            :class="{
                                              errors: errors[0],
                                              success:
                                                director.country_of_residence &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <label for="Country">
                                                Country of Residence*
                                              </label>
                                              <multiselect
                                                placeholder=""
                                                v-model="
                                                  director.country_of_residence
                                                "
                                                :show-labels="false"
                                                :options="residence_countrys"
                                                :searchable="false"
                                                label="name"
                                                track-by="name"
                                              >
                                                <template
                                                  slot="option"
                                                  slot-scope="props"
                                                >
                                                  <span
                                                    :class="
                                                      props.option.flagClass
                                                    "
                                                  ></span>
                                                  <div class="option__desc">
                                                    <span class="option__title">
                                                      {{ props.option.name }}
                                                    </span>
                                                  </div>
                                                </template>
                                              </multiselect>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length && errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  director.country_of_residence &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                                <li></li>
                                <li></li>
                                <li>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'directorAddress_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.addressLine1,
                                            success: director.addressLine1,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.addressLine1"
                                              class="form-control"
                                              :id="'directorAddress_' + index"
                                              placeholder="Address Line 1*"
                                            />
                                            <label
                                              :for="'directorAddress_' + index"
                                              class="control-label"
                                            >
                                              Address Line 1*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.addressLine1
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.addressLine1"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <div class="form-group">
                                        <span class="float-label">
                                          <input
                                            type="text"
                                            v-model="director.addressLine2"
                                            class="form-control"
                                            :id="'directorAddresstwo_' + index"
                                            placeholder="Address Line 2"
                                          />
                                          <label
                                            :for="'directorAddresstwo_' + index"
                                            class="control-label"
                                          >
                                            Address Line 2
                                          </label>
                                          <div class="line"></div>
                                        </span>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'directorTown_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !director.town,
                                            success: director.town,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.town"
                                              class="form-control"
                                              :id="'directorTown_' + index"
                                              placeholder="Town*"
                                            />
                                            <label
                                              :for="'directorTown_' + index"
                                              class="control-label"
                                            >
                                              Town*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length && !director.town
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.town"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'directorCity_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !director.city,
                                            success: director.city,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.city"
                                              class="form-control"
                                              :id="'directorCity_' + index"
                                              placeholder="City*"
                                            />
                                            <label
                                              :for="'directorCity_' + index"
                                              class="control-label"
                                            >
                                              City*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length && !director.city
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.city"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'directorSprc_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !director.sprc,
                                            success: director.sprc,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.sprc"
                                              class="form-control"
                                              :id="'directorSprc_' + index"
                                              placeholder="State/Province/Region/County*"
                                            />
                                            <label
                                              :for="'directorSprc_' + index"
                                              class="control-label"
                                            >
                                              State/Province/Region/County*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length && !director.sprc
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.sprc"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'directorPostCode_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.postCode,
                                            success: director.postCode,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="director.postCode"
                                              class="form-control"
                                              :id="'directorPostCode_' + index"
                                              placeholder="Post/Zip Code*"
                                            />
                                            <label
                                              :for="'directorPostCode_' + index"
                                              class="control-label"
                                            >
                                              Post/Zip Code*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.postCode
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.postCode"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <div class="head">
                                        <label class="mb-1">
                                          Date of Birth
                                        </label>
                                      </div>
                                      <ValidationProvider
                                        :name="'director_dob' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.date_of_birth,
                                            success: director.date_of_birth,
                                          }"
                                        >
                                          <span class="float-label">
                                            <dropdown-datepicker
                                              :daySuffixes="false"
                                              :ref="'directorPicker' + index"
                                              month-format="short"
                                              display-format="dmy"
                                              v-model="director.date_of_birth"
                                              :id="'director_' + index"
                                            ></dropdown-datepicker>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !director.date_of_birth
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="director.date_of_birth"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <div class="head d-none d-md-block">
                                        <label class="mb-1">&nbsp;</label>
                                      </div>
                                      <ValidationProvider
                                        :name="'cob_' + index"
                                        :rules="
                                          currentTabIndex == 0 ? 'required' : ''
                                        "
                                        v-slot="{ errors }"
                                      >
                                        <div class="country-dropdown">
                                          <div
                                            class="form-group form-select multiselect-grp"
                                            :class="{
                                              errors: errors[0],
                                              success:
                                                director.countryofBirth &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <label for="Country">
                                                Country of Birth*
                                              </label>
                                              <multiselect
                                                placeholder=""
                                                v-model="
                                                  director.countryofBirth
                                                "
                                                :show-labels="false"
                                                :options="
                                                  countryofBirth_options
                                                "
                                                :searchable="false"
                                                label="name"
                                                track-by="name"
                                              >
                                                <template
                                                  slot="option"
                                                  slot-scope="props"
                                                >
                                                  <span
                                                    :class="
                                                      props.option.flagClass
                                                    "
                                                  ></span>
                                                  <div class="option__desc">
                                                    <span class="option__title">
                                                      {{ props.option.name }}
                                                    </span>
                                                  </div>
                                                </template>
                                              </multiselect>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length && errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  director.countryofBirth &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <div
                                        class="d-flex align-items-center justify-content-between mb-3"
                                      >
                                        <p class="mb-0 mr-3 custom-switch-text">
                                          Is director serving as Shareholder?
                                          <span class="text-danger">*</span>
                                        </p>
                                        <div
                                          class="custom-switch success-handle"
                                        >
                                          <input
                                            type="checkbox"
                                            class="custom-switch-input"
                                            :id="
                                              'isServingShareholder_' + index
                                            "
                                            v-model="
                                              director.isServingShareholder
                                            "
                                          />
                                          <label
                                            class="custom-switch-label"
                                            :for="
                                              'isServingShareholder_' + index
                                            "
                                          >
                                            <span class="custom-switch-text1">
                                              Yes
                                            </span>
                                            <span class="custom-switch-text2">
                                              No
                                            </span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'direOwnership_' + index"
                                        :rules="
                                          director.isServingShareholder
                                            ? 'required'
                                            : ''
                                        "
                                        v-slot="{ errors }"
                                        v-if="director.isServingShareholder"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !director.ownership,
                                            success: director.ownership,
                                          }"
                                        >
                                          <span class="float-label">
                                            <b-input-group append="%">
                                              <b-form-input
                                                type="text"
                                                v-model="director.ownership"
                                                :id="'direOwnership_' + index"
                                                :data-index="index"
                                                placeholder="Ownership Percentage*"
                                                @change="
                                                  checkSharholderOwnership(
                                                    director.ownership,
                                                    index,
                                                    'director',
                                                  )
                                                "
                                                @keyup="
                                                  handleInput(
                                                    $event,
                                                    'director',
                                                  )
                                                "
                                                @keydown="checkDecimals($event)"
                                              ></b-form-input>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !director.ownership
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="director.ownership"
                                              ></i>
                                            </b-input-group>
                                            <label
                                              :for="'direOwnership_' + index"
                                              class="control-label"
                                            >
                                              Ownership Percentage*
                                            </label>
                                            <div class="line"></div>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div
                              id="add_director"
                              class="mb-3"
                              @click="addDirector"
                            >
                              <b-button variant="primary" size="lg">
                                <i class="fa fa-plus-circle fa-lg mr-2"></i>
                                <span class="my-auto">
                                  ADD ANOTHER DIRECTORS
                                </span>
                              </b-button>
                            </div>
                          </li>
                          <!-- Directors -->
                          <li>
                            <span
                              class="mt-2 mb-2 pb-2 border-top d-block"
                            ></span>
                          </li>
                          <!-- Shareholders -->
                          <li>
                            <h6 class="mb-3 font-15">
                              <i class="fa fa-level-up fa-rotate-90"></i>
                              <strong>Shareholders</strong>
                            </h6>
                          </li>
                          <li>
                            <b-tabs
                              content-class="px-0"
                              class="shareholders-tab"
                              nav-class="nav-tabs-new2"
                              :no-nav-style="true"
                              v-model="currentTabIndex"
                            >
                              <!-- Individual Tab -->
                              <b-tab title="Individual">
                                <div
                                  class="form-repeat"
                                  v-for="(individual, index) in individuals"
                                  :key="index"
                                >
                                  <!-- Individual Form -->
                                  <ul class="list-unstyled mb-0">
                                    <li
                                      class="d-flex justify-content-between align-items-center mb-3"
                                      v-if="index !== 0"
                                    >
                                      <h6 class="mb-0 font-15">
                                        <i
                                          class="fa fa-level-up fa-rotate-90"
                                        ></i>
                                        <strong>Shareholder</strong>
                                      </h6>
                                      <button
                                        class="btn btn-danger"
                                        @click="removeIndividuals(index)"
                                      >
                                        <i class="fa fa-times"></i>
                                      </button>
                                    </li>
                                    <li>
                                      <div class="row">
                                        <div
                                          class="col-lg-4 col-md-6 col-sm-12"
                                        >
                                          <ValidationProvider
                                            :name="'subFirstName_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.first_name,
                                                success: individual.first_name,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="
                                                    individual.first_name
                                                  "
                                                  class="form-control"
                                                  :id="'subFirstName_' + index"
                                                  placeholder="First Name*"
                                                />
                                                <label
                                                  :for="'subFirstName_' + index"
                                                  class="control-label"
                                                >
                                                  First Name*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.first_name
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.first_name"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div
                                          class="col-lg-4 col-md-6 col-sm-12"
                                        >
                                          <div class="form-group">
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="individual.middle_name"
                                                class="form-control"
                                                :id="'subMiddleName_' + index"
                                                placeholder="Middle Name"
                                              />
                                              <label
                                                :for="'subMiddleName_' + index"
                                                class="control-label"
                                              >
                                                Middle Name
                                              </label>
                                              <div class="line"></div>
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          class="col-lg-4 col-md-6 col-sm-12"
                                        >
                                          <ValidationProvider
                                            :name="'subLastName_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.last_name,
                                                success: individual.last_name,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="individual.last_name"
                                                  class="form-control"
                                                  :id="'subLastName_' + index"
                                                  placeholder="Last Name*"
                                                />
                                                <label
                                                  :for="'subLastName_' + index"
                                                  class="control-label"
                                                >
                                                  Last Name*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.last_name
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.last_name"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'subNationality_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div class="country-dropdown">
                                              <div
                                                class="form-group form-select multiselect-grp"
                                                :class="{
                                                  errors: errors[0],
                                                  success:
                                                    individual.nationality &&
                                                    !errors[0],
                                                }"
                                              >
                                                <span class="float-label">
                                                  <label for="Country">
                                                    Nationality*
                                                  </label>
                                                  <multiselect
                                                    placeholder=""
                                                    v-model="
                                                      individual.nationality
                                                    "
                                                    :show-labels="false"
                                                    :options="
                                                      nationality_countrys
                                                    "
                                                    :searchable="false"
                                                    label="name"
                                                    track-by="name"
                                                  >
                                                    <template
                                                      slot="option"
                                                      slot-scope="props"
                                                    >
                                                      <span
                                                        :class="
                                                          props.option.flagClass
                                                        "
                                                      ></span>
                                                      <div class="option__desc">
                                                        <span
                                                          class="option__title"
                                                        >
                                                          {{
                                                            props.option.name
                                                          }}
                                                        </span>
                                                      </div>
                                                    </template>
                                                  </multiselect>
                                                  <i
                                                    class="fa fa-times"
                                                    v-if="
                                                      errors.length && errors[0]
                                                    "
                                                  ></i>
                                                  <i
                                                    class="fa fa-check"
                                                    v-if="
                                                      individual.nationality &&
                                                      !errors[0]
                                                    "
                                                  ></i>
                                                </span>
                                              </div>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="
                                              'subResidenceCountry_' + index
                                            "
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div class="country-dropdown">
                                              <div
                                                class="form-group form-select multiselect-grp"
                                                :class="{
                                                  errors: errors[0],
                                                  success:
                                                    individual.country_of_residence &&
                                                    !errors[0],
                                                }"
                                              >
                                                <span class="float-label">
                                                  <label for="Country">
                                                    Country of Residence*
                                                  </label>
                                                  <multiselect
                                                    placeholder=""
                                                    v-model="
                                                      individual.country_of_residence
                                                    "
                                                    :show-labels="false"
                                                    :options="
                                                      residence_countrys
                                                    "
                                                    :searchable="false"
                                                    label="name"
                                                    track-by="name"
                                                  >
                                                    <template
                                                      slot="option"
                                                      slot-scope="props"
                                                    >
                                                      <span
                                                        :class="
                                                          props.option.flagClass
                                                        "
                                                      ></span>
                                                      <div class="option__desc">
                                                        <span
                                                          class="option__title"
                                                        >
                                                          {{
                                                            props.option.name
                                                          }}
                                                        </span>
                                                      </div>
                                                    </template>
                                                  </multiselect>
                                                  <i
                                                    class="fa fa-times"
                                                    v-if="
                                                      errors.length && errors[0]
                                                    "
                                                  ></i>
                                                  <i
                                                    class="fa fa-check"
                                                    v-if="
                                                      individual.country_of_residence &&
                                                      !errors[0]
                                                    "
                                                  ></i>
                                                </span>
                                              </div>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'individualAddress_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.addressLine1,
                                                success:
                                                  individual.addressLine1,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="
                                                    individual.addressLine1
                                                  "
                                                  class="form-control"
                                                  :id="
                                                    'individualAddress_' + index
                                                  "
                                                  placeholder="Address Line 1*"
                                                />
                                                <label
                                                  :for="
                                                    'individualAddress_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  Address Line 1*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.addressLine1
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.addressLine1"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <div class="form-group">
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  individual.addressLine2
                                                "
                                                class="form-control"
                                                :id="
                                                  'individualAddresstwo_' +
                                                  index
                                                "
                                                placeholder="Address Line 2"
                                              />
                                              <label
                                                :for="
                                                  'individualAddresstwo_' +
                                                  index
                                                "
                                                class="control-label"
                                              >
                                                Address Line 2
                                              </label>
                                              <div class="line"></div>
                                            </span>
                                          </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'individualTown_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.town,
                                                success: individual.town,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="individual.town"
                                                  class="form-control"
                                                  :id="
                                                    'individualTown_' + index
                                                  "
                                                  placeholder="Town*"
                                                />
                                                <label
                                                  :for="
                                                    'individualTown_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  Town*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.town
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.town"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'individualCity_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.city,
                                                success: individual.city,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="individual.city"
                                                  class="form-control"
                                                  :id="
                                                    'individualCity_' + index
                                                  "
                                                  placeholder="City*"
                                                />
                                                <label
                                                  :for="
                                                    'individualCity_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  City*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.city
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.city"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'individualSprc_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.sprc,
                                                success: individual.sprc,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="individual.sprc"
                                                  class="form-control"
                                                  :id="
                                                    'individualSprc_' + index
                                                  "
                                                  placeholder="State/Province/Region/County*"
                                                />
                                                <label
                                                  :for="
                                                    'individualSprc_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  State/Province/Region/County*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.sprc
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.sprc"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="
                                              'individualPostCode_' + index
                                            "
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.postCode,
                                                success: individual.postCode,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="individual.postCode"
                                                  class="form-control"
                                                  :id="
                                                    'individualPostCode_' +
                                                    index
                                                  "
                                                  placeholder="Post/Zip Code*"
                                                />
                                                <label
                                                  :for="
                                                    'individualPostCode_' +
                                                    index
                                                  "
                                                  class="control-label"
                                                >
                                                  Post/Zip Code*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.postCode
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.postCode"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'subOccupation_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.occupation,
                                                success: individual.occupation,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="
                                                    individual.occupation
                                                  "
                                                  class="form-control"
                                                  :id="'subOccupation_' + index"
                                                  placeholder="Occupation*"
                                                />
                                                <label
                                                  :for="
                                                    'subOccupation_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  Occupation*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.occupation
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="individual.occupation"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'individualcob_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div class="country-dropdown">
                                              <div
                                                class="form-group form-select multiselect-grp"
                                                :class="{
                                                  errors: errors[0],
                                                  success:
                                                    individual.countryofBirth &&
                                                    !errors[0],
                                                }"
                                              >
                                                <span class="float-label">
                                                  <label for="Country">
                                                    Country of Birth*
                                                  </label>
                                                  <multiselect
                                                    placeholder=""
                                                    v-model="
                                                      individual.countryofBirth
                                                    "
                                                    :show-labels="false"
                                                    :options="
                                                      countryofBirth_options
                                                    "
                                                    :searchable="false"
                                                    label="name"
                                                    track-by="name"
                                                  >
                                                    <template
                                                      slot="option"
                                                      slot-scope="props"
                                                    >
                                                      <span
                                                        :class="
                                                          props.option.flagClass
                                                        "
                                                      ></span>
                                                      <div class="option__desc">
                                                        <span
                                                          class="option__title"
                                                        >
                                                          {{
                                                            props.option.name
                                                          }}
                                                        </span>
                                                      </div>
                                                    </template>
                                                  </multiselect>
                                                  <i
                                                    class="fa fa-times"
                                                    v-if="
                                                      errors.length && errors[0]
                                                    "
                                                  ></i>
                                                  <i
                                                    class="fa fa-check"
                                                    v-if="
                                                      individual.countryofBirth &&
                                                      !errors[0]
                                                    "
                                                  ></i>
                                                </span>
                                              </div>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                          <div class="head">
                                            <label class="mb-1">
                                              Date of Birth
                                            </label>
                                          </div>
                                          <ValidationProvider
                                            :name="'individual_dob' + index"
                                            rules="required"
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.date_of_birth,
                                                success:
                                                  individual.date_of_birth,
                                              }"
                                            >
                                              <span class="float-label">
                                                <dropdown-datepicker
                                                  :daySuffixes="false"
                                                  :ref="
                                                    'individualPicker' + index
                                                  "
                                                  month-format="short"
                                                  display-format="dmy"
                                                  v-model="
                                                    individual.date_of_birth
                                                  "
                                                  :id="'indivisual_' + index"
                                                ></dropdown-datepicker>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !individual.date_of_birth
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="
                                                    individual.date_of_birth
                                                  "
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'subOwnership_' + index"
                                            :rules="
                                              currentTabIndex == 0
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !individual.ownership,
                                                success: individual.ownership,
                                              }"
                                            >
                                              <span class="float-label">
                                                <b-input-group append="%">
                                                  <b-form-input
                                                    type="text"
                                                    v-model="
                                                      individual.ownership
                                                    "
                                                    :id="
                                                      'subOwnership_' + index
                                                    "
                                                    :data-index="index"
                                                    placeholder="Ownership Percentage*"
                                                    @change="
                                                      checkSharholderOwnership(
                                                        individual.ownership,
                                                        index,
                                                        'shareholder',
                                                      )
                                                    "
                                                    @keyup="
                                                      handleInput(
                                                        $event,
                                                        'shareholder',
                                                      )
                                                    "
                                                    @keydown="
                                                      checkDecimals($event)
                                                    "
                                                  ></b-form-input>
                                                  <i
                                                    class="fa fa-times"
                                                    v-if="
                                                      errors.length &&
                                                      !individual.ownership
                                                    "
                                                  ></i>
                                                  <i
                                                    class="fa fa-check"
                                                    v-if="individual.ownership"
                                                  ></i>
                                                </b-input-group>
                                                <label
                                                  :for="'subOwnership_' + index"
                                                  class="control-label"
                                                >
                                                  Ownership Percentage*
                                                </label>
                                                <div class="line"></div>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                <div
                                  id="add_individual"
                                  class="mb-3"
                                  @click="addIndividuals"
                                >
                                  <b-button variant="primary" size="lg">
                                    <i class="fa fa-plus-circle fa-lg mr-2"></i>
                                    <span class="my-auto">
                                      ADD ANOTHER INDIVIDUAL SHAREHOLDERS
                                    </span>
                                  </b-button>
                                </div>
                              </b-tab>

                              <!-- Corporate Tab -->
                              <b-tab title="Corporate">
                                <div
                                  class="form-repeat"
                                  v-for="(corporate, index) in corporates"
                                  :key="index"
                                >
                                  <!-- Corporate Form -->
                                  <ul class="list-unstyled mb-0">
                                    <li
                                      class="d-flex justify-content-between align-items-center mb-3"
                                      v-if="index !== 0"
                                    >
                                      <h6 class="mb-0 font-15">
                                        <i
                                          class="fa fa-level-up fa-rotate-90"
                                        ></i>
                                        <strong>Corporate</strong>
                                      </h6>
                                      <button
                                        class="btn btn-danger"
                                        @click="removeCorporate(index)"
                                      >
                                        <i class="fa fa-times"></i>
                                      </button>
                                    </li>
                                    <li>
                                      <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'companyName_' + index"
                                            :rules="
                                              currentTabIndex == 1
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !corporate.companyName,
                                                success: corporate.companyName,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="
                                                    corporate.companyName
                                                  "
                                                  class="form-control"
                                                  :id="'companyName_' + index"
                                                  placeholder="Company Name*"
                                                />
                                                <label
                                                  :for="'companyName_' + index"
                                                  class="control-label"
                                                >
                                                  Company Name*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !corporate.companyName
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="corporate.companyName"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'companyCountry_' + index"
                                            :rules="
                                              currentTabIndex == 1
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div class="country-dropdown">
                                              <div
                                                class="form-group form-select multiselect-grp"
                                                :class="{
                                                  errors: errors[0],
                                                  success:
                                                    corporate.country_of_residence &&
                                                    !errors[0],
                                                }"
                                              >
                                                <span class="float-label">
                                                  <label for="Country">
                                                    Country of Residence*
                                                  </label>
                                                  <multiselect
                                                    placeholder=""
                                                    v-model="
                                                      corporate.country_of_residence
                                                    "
                                                    :show-labels="false"
                                                    :options="
                                                      residence_countrys
                                                    "
                                                    :searchable="false"
                                                    label="name"
                                                    track-by="name"
                                                  >
                                                    <template
                                                      slot="option"
                                                      slot-scope="props"
                                                    >
                                                      <span
                                                        :class="
                                                          props.option.flagClass
                                                        "
                                                      ></span>
                                                      <div class="option__desc">
                                                        <span
                                                          class="option__title"
                                                        >
                                                          {{
                                                            props.option.name
                                                          }}
                                                        </span>
                                                      </div>
                                                    </template>
                                                  </multiselect>
                                                  <i
                                                    class="fa fa-times"
                                                    v-if="
                                                      errors.length && errors[0]
                                                    "
                                                  ></i>
                                                  <i
                                                    class="fa fa-check"
                                                    v-if="
                                                      corporate.country_of_residence &&
                                                      !errors[0]
                                                    "
                                                  ></i>
                                                </span>
                                              </div>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'corporateAddress_' + index"
                                            :rules="
                                              currentTabIndex == 1
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !corporate.addressLine1,
                                                success: corporate.addressLine1,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="
                                                    corporate.addressLine1
                                                  "
                                                  class="form-control"
                                                  :id="
                                                    'corporateAddress_' + index
                                                  "
                                                  placeholder="Address Line 1*"
                                                />
                                                <label
                                                  :for="
                                                    'corporateAddress_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  Address Line 1*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !corporate.addressLine1
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="corporate.addressLine1"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <div class="form-group">
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="corporate.addressLine2"
                                                class="form-control"
                                                :id="
                                                  'corporateAddressTwo_' + index
                                                "
                                                placeholder="Address Line 2"
                                              />
                                              <label
                                                :for="
                                                  'corporateAddressTwo_' + index
                                                "
                                                class="control-label"
                                              >
                                                Address Line 2
                                              </label>
                                              <div class="line"></div>
                                            </span>
                                          </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'corporateTown_' + index"
                                            :rules="
                                              currentTabIndex == 1
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !corporate.town,
                                                success: corporate.town,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="corporate.town"
                                                  class="form-control"
                                                  :id="'corporateTown_' + index"
                                                  placeholder="Town*"
                                                />
                                                <label
                                                  :for="
                                                    'corporateTown_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  Town*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !corporate.town
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="corporate.town"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'corporateCity_' + index"
                                            :rules="
                                              currentTabIndex == 1
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !corporate.city,
                                                success: corporate.city,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="corporate.city"
                                                  class="form-control"
                                                  :id="'corporateCity_' + index"
                                                  placeholder="City*"
                                                />
                                                <label
                                                  :for="
                                                    'corporateCity_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  City*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !corporate.city
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="corporate.city"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'corporateSprc_' + index"
                                            :rules="
                                              currentTabIndex == 1
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !corporate.sprc,
                                                success: corporate.sprc,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="corporate.sprc"
                                                  class="form-control"
                                                  :id="'corporateSprc_' + index"
                                                  placeholder="State/Province/Region/County*"
                                                />
                                                <label
                                                  :for="
                                                    'corporateSprc_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  State/Province/Region/County*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !corporate.sprc
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="corporate.sprc"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                          <ValidationProvider
                                            :name="'corporatePostCode_' + index"
                                            :rules="
                                              currentTabIndex == 1
                                                ? 'required'
                                                : ''
                                            "
                                            v-slot="{ errors }"
                                          >
                                            <div
                                              class="form-group"
                                              :class="{
                                                errors:
                                                  errors.length &&
                                                  !corporate.postCode,
                                                success: corporate.postCode,
                                              }"
                                            >
                                              <span class="float-label">
                                                <input
                                                  type="text"
                                                  v-model="corporate.postCode"
                                                  class="form-control"
                                                  :id="
                                                    'corporatePostCode_' + index
                                                  "
                                                  placeholder="Post/Zip Code*"
                                                />
                                                <label
                                                  :for="
                                                    'corporatePostCode_' + index
                                                  "
                                                  class="control-label"
                                                >
                                                  Post/Zip Code*
                                                </label>
                                                <div class="line"></div>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length &&
                                                    !corporate.postCode
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="corporate.postCode"
                                                ></i>
                                              </span>
                                            </div>
                                          </ValidationProvider>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                <div
                                  id="add_corporate"
                                  class="mb-3"
                                  @click="addCorporate"
                                >
                                  <b-button variant="primary" size="lg">
                                    <i class="fa fa-plus-circle fa-lg mr-2"></i>
                                    <span class="my-auto">
                                      ADD ANOTHER CORPORATE
                                    </span>
                                  </b-button>
                                </div>
                              </b-tab>
                            </b-tabs>
                          </li>
                          <!-- Shareholders -->
                          <li>
                            <span
                              class="mt-2 mb-2 pb-2 border-top d-block"
                            ></span>
                          </li>
                          <!-- Ultimate Beneficial Owner (UBO) -->
                          <li>
                            <h6 class="mb-3 font-15">
                              <i class="fa fa-level-up fa-rotate-90"></i>
                              <strong>Ultimate Beneficial Owner (UBO)</strong>
                            </h6>
                          </li>
                          <li>
                            <div
                              class="form-repeat"
                              v-for="(owner, index) in ownerDatas"
                              :key="index"
                            >
                              <ul class="list-unstyled mb-0">
                                <li
                                  class="d-flex justify-content-between align-items-center mb-3"
                                  v-if="index !== 0"
                                >
                                  <h6 class="mb-0 font-15">
                                    <i class="fa fa-level-up fa-rotate-90"></i>
                                    <strong>
                                      Ultimate Beneficial Owner (UBO)
                                    </strong>
                                  </h6>
                                  <button
                                    class="btn btn-danger"
                                    @click="removeUBO(index)"
                                  >
                                    <i class="fa fa-times"></i>
                                  </button>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'uboFirstName_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !owner.first_name,
                                            success: owner.first_name,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.first_name"
                                              class="form-control"
                                              :id="'uboFirstName_' + index"
                                              placeholder="First Name*"
                                            />
                                            <label
                                              :for="'uboFirstName_' + index"
                                              class="control-label"
                                            >
                                              First Name*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !owner.first_name
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.first_name"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'uboMiddleName_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !owner.middle_name,
                                            success: owner.middle_name,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.middle_name"
                                              class="form-control"
                                              :id="'uboMiddleName_' + index"
                                              placeholder="Middle Name*"
                                            />
                                            <label
                                              :for="'uboMiddleName_' + index"
                                              class="control-label"
                                            >
                                              Middle Name*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !owner.middle_name
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.middle_name"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'uboLastName_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !owner.last_name,
                                            success: owner.last_name,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.last_name"
                                              class="form-control"
                                              :id="'uboLastName_' + index"
                                              placeholder="Last Name*"
                                            />
                                            <label
                                              :for="'uboLastName_' + index"
                                              class="control-label"
                                            >
                                              Last Name*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !owner.last_name
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.last_name"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'uboOwnership_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !owner.ownership,
                                            success: owner.ownership,
                                          }"
                                        >
                                          <span class="float-label">
                                            <b-input-group append="%">
                                              <b-form-input
                                                type="text"
                                                v-model="owner.ownership"
                                                :id="'uboOwnership_' + index"
                                                placeholder="Ownership*"
                                                @input="
                                                  ownerPercentage(
                                                    owner.ownership,
                                                    index,
                                                  )
                                                "
                                              ></b-form-input>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !owner.ownership
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="owner.ownership"
                                              ></i>
                                            </b-input-group>
                                            <label
                                              :for="'uboOwnership_' + index"
                                              class="control-label"
                                            >
                                              Ownership Percentage*
                                            </label>
                                            <div class="line"></div>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'uboOccupation_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !owner.occupation,
                                            success: owner.occupation,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.occupation"
                                              class="form-control"
                                              :id="'uboOccupation_' + index"
                                              placeholder="Occupation*"
                                            />
                                            <label
                                              :for="'uboOccupation_' + index"
                                              class="control-label"
                                            >
                                              Occupation*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !owner.occupation
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.occupation"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'uboNationality_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="country-dropdown">
                                          <div
                                            class="form-group form-select multiselect-grp"
                                            :class="{
                                              errors: errors[0],
                                              success:
                                                owner.nationality && !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <label for="Country">
                                                Nationality*
                                              </label>
                                              <multiselect
                                                placeholder=""
                                                v-model="owner.nationality"
                                                :show-labels="false"
                                                :options="nationality_countrys"
                                                :searchable="false"
                                                label="name"
                                                track-by="name"
                                              >
                                                <template
                                                  slot="option"
                                                  slot-scope="props"
                                                >
                                                  <span
                                                    :class="
                                                      props.option.flagClass
                                                    "
                                                  ></span>
                                                  <div class="option__desc">
                                                    <span class="option__title">
                                                      {{ props.option.name }}
                                                    </span>
                                                  </div>
                                                </template>
                                              </multiselect>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length && errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  owner.nationality &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'uboResidenceCountry_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="country-dropdown">
                                          <div
                                            class="form-group form-select multiselect-grp"
                                            :class="{
                                              errors: errors[0],
                                              success:
                                                owner.country_of_residence &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <label for="Country">
                                                Country of Residence*
                                              </label>
                                              <multiselect
                                                placeholder=""
                                                v-model="
                                                  owner.country_of_residence
                                                "
                                                :show-labels="false"
                                                :options="residence_countrys"
                                                :searchable="false"
                                                label="name"
                                                track-by="name"
                                              >
                                                <template
                                                  slot="option"
                                                  slot-scope="props"
                                                >
                                                  <span
                                                    :class="
                                                      props.option.flagClass
                                                    "
                                                  ></span>
                                                  <div class="option__desc">
                                                    <span class="option__title">
                                                      {{ props.option.name }}
                                                    </span>
                                                  </div>
                                                </template>
                                              </multiselect>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length && errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  owner.country_of_residence &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'owner_Address_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !owner.addressLine1,
                                            success: owner.addressLine1,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.addressLine1"
                                              class="form-control"
                                              :id="'owner_Address_' + index"
                                              placeholder="Address Line 1*"
                                            />
                                            <label
                                              :for="'owner_Address_' + index"
                                              class="control-label"
                                            >
                                              Address Line 1*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !owner.addressLine1
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.addressLine1"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <div class="form-group">
                                        <span class="float-label">
                                          <input
                                            type="text"
                                            v-model="owner.addressLine2"
                                            class="form-control"
                                            :id="'owner_Address_' + index"
                                            placeholder="Address Line 2"
                                          />
                                          <label
                                            :for="'owner_Address_' + index"
                                            class="control-label"
                                          >
                                            Address Line 2
                                          </label>
                                          <div class="line"></div>
                                        </span>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'ownerTown_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !owner.town,
                                            success: owner.town,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.town"
                                              class="form-control"
                                              :id="'ownerTown_' + index"
                                              placeholder="Town*"
                                            />
                                            <label
                                              :for="'ownerTown_' + index"
                                              class="control-label"
                                            >
                                              Town*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length && !owner.town
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.town"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'ownerCity_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !owner.city,
                                            success: owner.city,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.city"
                                              class="form-control"
                                              :id="'ownerCity_' + index"
                                              placeholder="City*"
                                            />
                                            <label
                                              :for="'ownerCity_' + index"
                                              class="control-label"
                                            >
                                              City*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length && !owner.city
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.city"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'ownerSprc_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !owner.sprc,
                                            success: owner.sprc,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.sprc"
                                              class="form-control"
                                              :id="'ownerSprc_' + index"
                                              placeholder="State/Province/Region/County*"
                                            />
                                            <label
                                              :for="'ownerSprc_' + index"
                                              class="control-label"
                                            >
                                              State/Province/Region/County*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length && !owner.sprc
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.sprc"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'ownerPostCode_' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length && !owner.postCode,
                                            success: owner.postCode,
                                          }"
                                        >
                                          <span class="float-label">
                                            <input
                                              type="text"
                                              v-model="owner.postCode"
                                              class="form-control"
                                              :id="'ownerPostCode_' + index"
                                              placeholder="Post/Zip Code*"
                                            />
                                            <label
                                              :for="'ownerPostCode_' + index"
                                              class="control-label"
                                            >
                                              Post/Zip Code*
                                            </label>
                                            <div class="line"></div>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length && !owner.postCode
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.postCode"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <div class="head">
                                        <label class="mb-1">
                                          Date of Birth
                                        </label>
                                      </div>
                                      <ValidationProvider
                                        :name="'owner_dob' + index"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div
                                          class="form-group"
                                          :class="{
                                            errors:
                                              errors.length &&
                                              !owner.date_of_birth,
                                            success: owner.date_of_birth,
                                          }"
                                        >
                                          <span class="float-label">
                                            <dropdown-datepicker
                                              :ref="'ubopicker' + index"
                                              :daySuffixes="false"
                                              month-format="short"
                                              display-format="dmy"
                                              v-model="owner.date_of_birth"
                                            ></dropdown-datepicker>
                                            <i
                                              class="fa fa-times"
                                              v-if="
                                                errors.length &&
                                                !owner.date_of_birth
                                              "
                                            ></i>
                                            <i
                                              class="fa fa-check"
                                              v-if="owner.date_of_birth"
                                            ></i>
                                          </span>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <ValidationProvider
                                        :name="'ownercob_' + index"
                                        :rules="
                                          currentTabIndex == 0 ? 'required' : ''
                                        "
                                        v-slot="{ errors }"
                                      >
                                        <div class="country-dropdown">
                                          <div
                                            class="form-group form-select multiselect-grp"
                                            :class="{
                                              errors: errors[0],
                                              success:
                                                owner.countryofBirth &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <label for="Country">
                                                Country of Birth*
                                              </label>
                                              <multiselect
                                                placeholder=""
                                                v-model="owner.countryofBirth"
                                                :show-labels="false"
                                                :options="
                                                  countryofBirth_options
                                                "
                                                :searchable="false"
                                                label="name"
                                                track-by="name"
                                              >
                                                <template
                                                  slot="option"
                                                  slot-scope="props"
                                                >
                                                  <span
                                                    :class="
                                                      props.option.flagClass
                                                    "
                                                  ></span>
                                                  <div class="option__desc">
                                                    <span class="option__title">
                                                      {{ props.option.name }}
                                                    </span>
                                                  </div>
                                                </template>
                                              </multiselect>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length && errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  owner.countryofBirth &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </div>
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div id="add_UBO" class="mb-3" @click="addUBO">
                              <b-button variant="primary" size="lg">
                                <i class="fa fa-plus-circle fa-lg mr-2"></i>
                                <span class="my-auto">
                                  ADD ANOTHER ULTIMATE BENEFICIAL OWNER(UBO)
                                </span>
                              </b-button>
                            </div>
                          </li>
                          <!-- Ultimate Beneficial Owner (UBO) -->
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm & Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Business Structure, Condition and Size -->
                <div
                  class="profile-collapse-list business-structure"
                  :class="[
                    {
                      active:
                        controllersSubmit &&
                        businessInfo.businessTypeTitle === 'Business',
                    },
                    businessStructure.businessStructureStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.business_structure
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="businessStructure.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="businessStructure.Icon"
                      />
                      Business Structure, Condition and Size
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="businessStructure.businessStructureStatusColor"
                      >
                        {{ businessStructure.businessStructureStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="business_structure"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="
                      controllersSubmit &&
                      businessInfo.businessTypeTitle === 'Business'
                    "
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(businessStructureForm)"
                        id="businessStructure_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is your business a parent of another?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="parentBusinessName"
                                  v-model="businessStructure.parentBusinessName"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="parentBusinessName"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="businessStructure.parentBusinessName">
                            <ValidationProvider
                              name="Parent_profile"
                              :rules="
                                businessStructure.parentBusinessName
                                  ? 'required'
                                  : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !businessStructure.parentProfile,
                                  success: businessStructure.parentProfile,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessStructure.parentProfile"
                                    class="form-control"
                                    id="Parent_profile"
                                    placeholder="Parent Profile*"
                                  />
                                  <label
                                    for="Parent_profile"
                                    class="control-label"
                                  >
                                    Parent Profile*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessStructure.parentProfile
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessStructure.parentProfile"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is your business a subsidiary of another
                                business?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="subsidiary"
                                  v-model="businessStructure.subsidiary"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="subsidiary"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="businessStructure.subsidiary">
                            <ValidationProvider
                              name="subsidiary_Name"
                              :rules="
                                businessStructure.subsidiary ? 'required' : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !businessStructure.subsidiaryName,
                                  success: businessStructure.subsidiaryName,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="businessStructure.subsidiaryName"
                                    class="form-control"
                                    id="subsidiary_Name"
                                    placeholder="Parent Name/ Business Activity/ Registration Number"
                                  />
                                  <label
                                    for="subsidiary_Name"
                                    class="control-label"
                                  >
                                    Parent Name/ Business Activity/ Registration
                                    Number
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !businessStructure.subsidiaryName
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="businessStructure.subsidiaryName"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li class="mt-3">
                            <div class="row">
                              <div class="col-lg-6 col-sm-12">
                                <ValidationProvider
                                  name="companyStatus"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          businessStructure.companyStatus &&
                                          !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">
                                          Company Status*
                                        </label>
                                        <multiselect
                                          placeholder=""
                                          v-model="
                                            businessStructure.companyStatus
                                          "
                                          :show-labels="false"
                                          :options="companyStatus_option"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            businessStructure.companyStatus &&
                                            !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-6 col-sm-12">
                                <ValidationProvider
                                  name="NoOfEmp"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          businessStructure.NoOfEmp &&
                                          !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">
                                          Number of Employees*
                                        </label>
                                        <multiselect
                                          placeholder=""
                                          v-model="businessStructure.NoOfEmp"
                                          :show-labels="false"
                                          :options="NoOfEmp_option"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            businessStructure.NoOfEmp &&
                                            !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="CurrentBTurnover"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          businessStructure.CurrentBTurnover &&
                                          !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">
                                          Current Business Turnover*
                                        </label>
                                        <multiselect
                                          placeholder=""
                                          v-model="
                                            businessStructure.CurrentBTurnover
                                          "
                                          :show-labels="false"
                                          :options="CurrentBTurnover_option"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            businessStructure.CurrentBTurnover &&
                                            !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="ExpectedBTurnover"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          businessStructure.ExpectedBTurnover &&
                                          !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">
                                          Expected Business Turnover*
                                        </label>
                                        <multiselect
                                          placeholder=""
                                          v-model="
                                            businessStructure.ExpectedBTurnover
                                          "
                                          :show-labels="false"
                                          :options="ExpectedBTurnover_option"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            businessStructure.ExpectedBTurnover &&
                                            !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="size"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          businessStructure.size && !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">Size*</label>
                                        <multiselect
                                          placeholder=""
                                          v-model="businessStructure.size"
                                          :show-labels="false"
                                          :options="size_option"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            businessStructure.size && !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>
                              </div>
                            </div>
                          </li>
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm &amp; Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Your Business and Regulations -->
                <div
                  class="profile-collapse-list regulations"
                  :class="[
                    {
                      active:
                        businessStructure.businessStructureSubmit &&
                        businessInfo.businessTypeTitle === 'Business',
                    },
                    regulations.regulationsStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.regulations
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="regulations.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="regulations.Icon"
                      />
                      Your Business and Regulations
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="regulations.regulationsStatusColor"
                      >
                        {{ regulations.regulationsStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="regulations"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="
                      businessStructure.businessStructureSubmit &&
                      businessInfo.businessTypeTitle === 'Business'
                    "
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(regulationsForm)"
                        id="regulations_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <div class="head">
                              <label>
                                Which industry is your business operating in?
                                <span class="text-danger">*</span>
                              </label>
                            </div>
                            <ValidationProvider
                              name="Industry Classification"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <div class="country-dropdown">
                                <div
                                  class="form-group form-select multiselect-grp"
                                  :class="{
                                    errors: errors[0],
                                    success:
                                      regulations.industryClassification &&
                                      !errors[0],
                                  }"
                                >
                                  <span class="float-label">
                                    <label for="Country">
                                      Industry Classification*
                                    </label>
                                    <multiselect
                                      placeholder=""
                                      v-model="
                                        regulations.industryClassification
                                      "
                                      :show-labels="false"
                                      :options="industryClassification_option"
                                      :searchable="false"
                                    ></multiselect>
                                    <i
                                      class="fa fa-times"
                                      v-if="errors.length && errors[0]"
                                    ></i>
                                    <i
                                      class="fa fa-check"
                                      v-if="
                                        regulations.industryClassification &&
                                        !errors[0]
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="ISIC Code"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="country-dropdown">
                                    <div
                                      class="form-group form-select multiselect-grp"
                                      :class="{
                                        errors: errors[0],
                                        success:
                                          regulations.ISIC_code && !errors[0],
                                      }"
                                    >
                                      <span class="float-label">
                                        <label for="Country">
                                          Confirm your Businesses ISIC Code*
                                        </label>
                                        <multiselect
                                          placeholder=""
                                          v-model="regulations.ISIC_code"
                                          :show-labels="false"
                                          :options="ISICCode_option"
                                          :searchable="false"
                                        ></multiselect>
                                        <i
                                          class="fa fa-times"
                                          v-if="errors.length && errors[0]"
                                        ></i>
                                        <i
                                          class="fa fa-check"
                                          v-if="
                                            regulations.ISIC_code && !errors[0]
                                          "
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="Registration Number"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length &&
                                        !regulations.registration_Number,
                                      success: regulations.registration_Number,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="
                                          regulations.registration_Number
                                        "
                                        class="form-control"
                                        id="registration_Number"
                                        placeholder="Registration Number*"
                                      />
                                      <label
                                        for="registration_Number"
                                        class="control-label"
                                      >
                                        Registration Number*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length &&
                                          !regulations.registration_Number
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="regulations.registration_Number"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <ValidationProvider
                                  name="Tax-ID"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div
                                    class="form-group"
                                    :class="{
                                      errors:
                                        errors.length && !regulations.Tax_ID,
                                      success: regulations.Tax_ID,
                                    }"
                                  >
                                    <span class="float-label">
                                      <input
                                        type="text"
                                        v-model="regulations.Tax_ID"
                                        class="form-control"
                                        id="Tax_ID"
                                        placeholder="Business Tax ID*"
                                      />
                                      <label for="Tax_ID" class="control-label">
                                        Business Tax ID*
                                      </label>
                                      <div class="line"></div>
                                      <i
                                        class="fa fa-times"
                                        v-if="
                                          errors.length && !regulations.Tax_ID
                                        "
                                      ></i>
                                      <i
                                        class="fa fa-check"
                                        v-if="regulations.Tax_ID"
                                      ></i>
                                    </span>
                                  </div>
                                </ValidationProvider>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is your business regulated?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isRegulated"
                                  v-model="regulations.isRegulated"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isRegulated"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="regulations.isRegulated">
                            <ValidationProvider
                              name="regulated_number"
                              :rules="regulations.isRegulated ? 'required' : ''"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !regulations.regulatedNumber,
                                  success: regulations.regulatedNumber,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="regulations.regulatedNumber"
                                    class="form-control"
                                    id="regulated_number"
                                    placeholder="Licence/Regulated Number*"
                                  />
                                  <label
                                    for="regulated_number"
                                    class="control-label"
                                  >
                                    Licence/Regulated Number*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !regulations.regulatedNumber
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="regulations.regulatedNumber"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is your business registered for VAT/Sales Tax?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isSalesTax"
                                  v-model="regulations.isSalesTax"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isSalesTax"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="regulations.isSalesTax">
                            <ValidationProvider
                              name="tax_number"
                              :rules="regulations.isSalesTax ? 'required' : ''"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length && !regulations.taxNumber,
                                  success: regulations.taxNumber,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="regulations.taxNumber"
                                    class="form-control"
                                    id="tax_number"
                                    placeholder="VAT/Sales Tax Number*"
                                  />
                                  <label for="tax_number" class="control-label">
                                    VAT/Sales Tax Number*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length && !regulations.taxNumber
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="regulations.taxNumber"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Do you have an AML Policy?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isAMLPolicy"
                                  v-model="regulations.isAMLPolicy"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isAMLPolicy"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="regulations.isAMLPolicy">
                            <ValidationProvider
                              name="policy_number"
                              :rules="regulations.isAMLPolicy ? 'required' : ''"
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !regulations.AMLPolicyNumber,
                                  success: regulations.AMLPolicyNumber,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="regulations.AMLPolicyNumber"
                                    class="form-control"
                                    id="policy_number"
                                    placeholder="Registration Number*"
                                  />
                                  <label
                                    for="policy_number"
                                    class="control-label"
                                  >
                                    Registration Number*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !regulations.AMLPolicyNumber
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="regulations.AMLPolicyNumber"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is your business registered for Data Protection?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isDataProtection"
                                  v-model="regulations.isDataProtection"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isDataProtection"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="regulations.isDataProtection">
                            <ValidationProvider
                              name="dataProtection_number"
                              :rules="
                                regulations.isDataProtection ? 'required' : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !regulations.dataProtectionNumber,
                                  success: regulations.dataProtectionNumber,
                                }"
                              >
                                <span class="float-label">
                                  <input
                                    type="text"
                                    v-model="regulations.dataProtectionNumber"
                                    class="form-control"
                                    id="dataProtection_number"
                                    placeholder="Registration Number*"
                                  />
                                  <label
                                    for="dataProtection_number"
                                    class="control-label"
                                  >
                                    Registration Number*
                                  </label>
                                  <div class="line"></div>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !regulations.dataProtectionNumber
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="regulations.dataProtectionNumber"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is your business PCI Certified?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isPCICertified"
                                  v-model="regulations.isPCICertified"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isPCICertified"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="regulations.isPCICertified">
                            <div class="head">
                              <label class="mb-1">
                                Date of Last Certification
                              </label>
                            </div>
                            <ValidationProvider
                              name="'regulations_certification'"
                              :rules="
                                regulations.isPCICertified ? 'required' : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !regulations.certificationDate,
                                  success: regulations.certificationDate,
                                }"
                              >
                                <span class="float-label">
                                  <dropdown-datepicker
                                    :daySuffixes="false"
                                    month-format="short"
                                    display-format="dmy"
                                    v-model="regulations.certificationDate"
                                  ></dropdown-datepicker>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !regulations.certificationDate
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="regulations.certificationDate"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Is your business ISO27001 Certified?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isISOCertified"
                                  v-model="regulations.isISOCertified"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isISOCertified"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li v-if="regulations.isISOCertified">
                            <div class="head">
                              <label class="mb-1">
                                Date of Last Certification
                              </label>
                            </div>
                            <ValidationProvider
                              name="'regulations_ISO'"
                              :rules="
                                regulations.isISOCertified ? 'required' : ''
                              "
                              v-slot="{ errors }"
                            >
                              <div
                                class="form-group"
                                :class="{
                                  errors:
                                    errors.length &&
                                    !regulations.ISOCertifiedDate,
                                  success: regulations.ISOCertifiedDate,
                                }"
                              >
                                <span class="float-label">
                                  <dropdown-datepicker
                                    :daySuffixes="false"
                                    month-format="short"
                                    display-format="dmy"
                                    v-model="regulations.ISOCertifiedDate"
                                  ></dropdown-datepicker>
                                  <i
                                    class="fa fa-times"
                                    v-if="
                                      errors.length &&
                                      !regulations.ISOCertifiedDate
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-check"
                                    v-if="regulations.ISOCertifiedDate"
                                  ></i>
                                </span>
                              </div>
                            </ValidationProvider>
                          </li>
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm &amp; Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Compliance Declarations -->
                <div
                  class="profile-collapse-list compliance-declarations"
                  :class="[
                    {
                      active:
                        (regulations.regulationsSubmit &&
                          businessInfo.businessTypeTitle === 'Business') ||
                        (account.accountIsSubmit &&
                          businessInfo.businessTypeTitle !== 'Business'),
                    },
                    complianceDec.complianceDecStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.compliance_declarations
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="complianceDec.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="complianceDec.Icon"
                      />
                      Compliance Declarations
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="complianceDec.complianceDecStatusColor"
                      >
                        {{ complianceDec.complianceDecStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="compliance_declarations"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="
                      (regulations.regulationsSubmit &&
                        businessInfo.businessTypeTitle === 'Business') ||
                      (account.accountIsSubmit &&
                        businessInfo.businessTypeTitle !== 'Business')
                    "
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(complianceDeclarationsForm)"
                        id="complianceDeclarations_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <h6 class="mb-3 font-15">
                              <i class="fa fa-level-up fa-rotate-90"></i>
                              <strong>
                                Almost there, just a few more regulatory and
                                compliance stuff
                              </strong>
                            </h6>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Have you or anyone involved in the
                                {{ businessInfo.businessTypeTitle }} been
                                convicted or facing the possibility of
                                conviction for a crime?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isPossibilityCrime"
                                  v-model="complianceDec.isPossibilityCrime"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isPossibilityCrime"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Are you or anyone involved in the
                                {{ businessInfo.businessTypeTitle }} considered
                                a politically exposed person?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isPoliticallyExposed"
                                  v-model="complianceDec.isPoliticallyExposed"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isPoliticallyExposed"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Have you or anyone involved in the
                                {{ businessInfo.businessTypeTitle }} been
                                declared insolvent or bankrupt?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isBankrupt"
                                  v-model="complianceDec.isBankrupt"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isBankrupt"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Are you or anyone involved in the
                                {{ businessInfo.businessTypeTitle }} involved in
                                terrorism or terrorism financing?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isTerrorism"
                                  v-model="complianceDec.isTerrorism"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isTerrorism"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Are you or anyone involved in the
                                {{ businessInfo.businessTypeTitle }} involved in
                                money laundering?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isLaundering"
                                  v-model="complianceDec.isLaundering"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isLaundering"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div
                              class="d-flex align-items-center justify-content-between mb-3"
                            >
                              <p class="mb-0 mr-3 custom-switch-text">
                                Are you or anyone involved in the
                                {{ businessInfo.businessTypeTitle }} involved in
                                dealing in arms or weapons?
                              </p>
                              <div class="custom-switch success-handle">
                                <input
                                  type="checkbox"
                                  class="custom-switch-input"
                                  id="isWeapons"
                                  v-model="complianceDec.isWeapons"
                                />
                                <label
                                  class="custom-switch-label"
                                  for="isWeapons"
                                >
                                  <span class="custom-switch-text1">Yes</span>
                                  <span class="custom-switch-text2">No</span>
                                </label>
                              </div>
                            </div>
                          </li>
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm &amp; Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- Supporting Documents -->
                <div
                  class="profile-collapse-list documents"
                  :class="[
                    { active: complianceDec.complianceDecSubmit },
                    documents.documentsStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.documents
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="documents.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="documents.Icon"
                      />
                      Supporting Documents
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="documents.documentsStatusColor"
                      >
                        {{ documents.documentsStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="documents"
                    class="documents-main"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="complianceDec.complianceDecSubmit"
                  >
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="upload-left">
                          <div class="document-type-dropdown">
                            <div
                              class="form-group form-select single-multiselect"
                            >
                              <span class="float-label">
                                <label for="c">Select Document Type</label>
                                <multiselect
                                  placeholder=""
                                  v-model="documents.documentType"
                                  :show-labels="false"
                                  :options="documentOptions"
                                  :searchable="false"
                                  label="name"
                                  track-by="name"
                                  @input="onChangeCheckType"
                                >
                                  <template slot="option" slot-scope="props">
                                    <div>
                                      <span class="option__title">
                                        {{ props.option.name }}
                                      </span>
                                    </div>
                                  </template>
                                </multiselect>
                              </span>
                            </div>
                          </div>
                          <div
                            class="document-type-dropdown"
                            v-if="selectedItemArray.wealthNames"
                          >
                            <div
                              class="form-group form-select single-multiselect"
                            >
                              <span class="float-label">
                                <label for="c">Select Wealth Document</label>
                                <multiselect
                                  placeholder=""
                                  v-model="documents.wealthType"
                                  :show-labels="false"
                                  :options="selectedItemArray.wealthNames"
                                  :searchable="false"
                                  label="name"
                                  track-by="name"
                                >
                                  <template slot="option" slot-scope="props">
                                    <div>
                                      <span class="option__title">
                                        {{ props.option.name }}
                                      </span>
                                    </div>
                                  </template>
                                </multiselect>
                              </span>
                            </div>
                          </div>
                          <div
                            class="upload-box"
                            @dragover="dragover"
                            @dragleave="dragleave"
                            @drop="drop"
                          >
                            <input
                              type="file"
                              multiple
                              name="fields[assetsFieldHandle][]"
                              id="assetsFieldHandle"
                              class="opacity-0 overflow-hidden absolute"
                              @change="onChangeFileUpload(documents.wealthType)"
                              ref="file"
                              accept=".pdf,.doc"
                            />
                            <label
                              for="assetsFieldHandle"
                              class="block cursor-pointer"
                            >
                              <i class="fa fa-upload fa-2x icon-primary"></i>
                              <p class="mt-3">
                                Click to upload pages of the document
                                <br />
                                <small>File Formate: JPG, PNG or PDF</small>
                                <br />
                                <small>File Size: 10MB</small>
                              </p>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="upload-right">
                          <form
                            @submit.prevent="documentsForm"
                            id="document_form"
                          >
                            <ul class="upload-list-group list-unstyled">
                              <template
                                v-for="(document, index) in documentTypeList"
                              >
                                <li
                                  class="d-flex justify-content-between flex-column"
                                  :key="index"
                                  v-if="
                                    businessInfo.businessTypeTitle ===
                                      'Business' ||
                                    (businessInfo.businessTypeTitle ===
                                      'Organisation' &&
                                      !document.isBusiness)
                                  "
                                >
                                  <h6
                                    class="mb-0 d-flex justify-content-between align-items-center"
                                  >
                                    {{ document.name }}
                                    <img
                                      src="@/assets/complete.svg"
                                      v-if="document.documents_count > 0"
                                      width="20"
                                    />
                                    <img
                                      src="@/assets/rejected.svg"
                                      v-if="
                                        documentError &&
                                        document.documents_count == 0
                                      "
                                      width="20"
                                    />
                                  </h6>
                                  <ul class="inner-list list-unstyled">
                                    <li
                                      v-for="(
                                        uploaddocument, fieIndex
                                      ) in document.documents"
                                      :key="fieIndex"
                                    >
                                      <p
                                        class="pl-4 ml-3 mb-0 d-flex justify-content-between align-items-center"
                                      >
                                        <span>- {{ uploaddocument.name }}</span>
                                        <small
                                          :id="
                                            'file_remove_' +
                                            index +
                                            '_' +
                                            fieIndex
                                          "
                                          class="badge badge-danger mx-0 cursor-pointer"
                                          @click="
                                            removeUploadFiles(
                                              $event,
                                              document.type,
                                              fieIndex,
                                            )
                                          "
                                        >
                                          Delete
                                        </small>
                                      </p>
                                    </li>
                                  </ul>
                                  <div class="second-inner">
                                    <ul
                                      class="inner-list list-unstyled"
                                      v-if="document.wealthNames"
                                    >
                                      <li
                                        v-for="(
                                          wealthsName, welthFileIndex
                                        ) in document.wealthNames"
                                        :key="welthFileIndex"
                                      >
                                        <h6
                                          class="mb-0 d-flex justify-content-between align-items-center"
                                        >
                                          <small>{{ wealthsName.name }}</small>
                                        </h6>
                                        <span
                                          v-if="wealthsName.wealthDocuments"
                                        >
                                          <p
                                            class="pl-5 mb-0 d-flex justify-content-between align-items-center"
                                            v-for="(
                                              wealthDoc, welthFileDocIndex
                                            ) in wealthsName.wealthDocuments"
                                            :key="welthFileDocIndex"
                                          >
                                            <span class="ml-3">
                                              - {{ wealthDoc.name }}
                                            </span>
                                            <small
                                              class="badge badge-danger mx-0 cursor-pointer"
                                              @click="
                                                removeUploadFiles(
                                                  $event,
                                                  document.type,
                                                  welthFileDocIndex,
                                                  wealthsName.wealthType,
                                                )
                                              "
                                            >
                                              Delete
                                            </small>
                                          </p>
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                              </template>
                              <li class="text-right submit-area">
                                <b-button
                                  type="submit"
                                  variant="primary ml-1"
                                  size="lg"
                                >
                                  Confirm & Save
                                </b-button>
                              </li>
                            </ul>
                          </form>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>

                <!-- Finally, in case we need to reach you who should we contact?  -->
                <div
                  class="profile-collapse-list last contact"
                  :class="[
                    { active: documents.documentsSubmit },
                    contacts.contactsStatusColor,
                  ]"
                >
                  <b-button
                    size="lg"
                    variant="light"
                    v-b-toggle.contact
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <h6 class="left mb-0">
                      <img
                        :src="contacts.Icon"
                        class="img-fluid"
                        alt=""
                        v-if="contacts.Icon"
                      />
                      Finally, in case we need to reach you who should we
                      contact?
                    </h6>
                    <div class="right d-flex align-items-center">
                      <h6
                        class="right-status mb-0 mr-3"
                        :class="contacts.contactsStatusColor"
                      >
                        {{ contacts.contactsStatus }}
                      </h6>
                      <strong class="collapse-icon">
                        <i class="fa fa-chevron-up"></i>
                      </strong>
                    </div>
                  </b-button>
                  <b-collapse
                    id="contact"
                    accordion="profile-accordion"
                    role="tabpanel"
                    :visible="documents.documentsSubmit"
                  >
                    <ValidationObserver v-slot="{ passes }">
                      <form
                        @submit.prevent="passes(contactForm)"
                        id="contact_form"
                      >
                        <ul class="list-unstyled mb-0">
                          <li>
                            <b-tabs
                              content-class="px-0"
                              class="administration-tab"
                              nav-class="nav-tabs-new2"
                              :no-nav-style="true"
                              v-model="currentContactsTabIndex"
                            >
                              <!-- Account Administration Tab -->
                              <b-tab title="Account Administration">
                                <ul class="list-unstyled mb-0">
                                  <li>
                                    <div class="row">
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          :name="'administration_country'"
                                          :rules="
                                            currentContactsTabIndex == 0
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div class="country-dropdown">
                                            <div
                                              class="form-group form-select multiselect-grp"
                                              :class="{
                                                errors: errors[0],
                                                success:
                                                  contacts.administration
                                                    .country && !errors[0],
                                              }"
                                            >
                                              <span class="float-label">
                                                <label for="c">Country*</label>
                                                <multiselect
                                                  placeholder=""
                                                  v-model="
                                                    contacts.administration
                                                      .country
                                                  "
                                                  :show-labels="false"
                                                  :options="residence_countrys"
                                                  :searchable="false"
                                                  label="name"
                                                  track-by="name"
                                                >
                                                  <template
                                                    slot="option"
                                                    slot-scope="props"
                                                  >
                                                    <span
                                                      :class="
                                                        props.option.flagClass
                                                      "
                                                    ></span>
                                                    <div class="option__desc">
                                                      <span
                                                        class="option__title"
                                                      >
                                                        {{ props.option.name }}
                                                      </span>
                                                    </div>
                                                  </template>
                                                </multiselect>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length && errors[0]
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="
                                                    contacts.administration
                                                      .country && !errors[0]
                                                  "
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="administration_name"
                                          :rules="
                                            currentContactsTabIndex == 0
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.administration.name,
                                              success:
                                                contacts.administration.name,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  contacts.administration.name
                                                "
                                                class="form-control"
                                                id="administration_name"
                                                placeholder="Name*"
                                              />
                                              <label
                                                for="administration_name"
                                                class="control-label"
                                              >
                                                Name*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.administration.name
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.administration.name
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="administration_email"
                                          :rules="
                                            currentContactsTabIndex == 0
                                              ? 'required|email'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                (errors.length &&
                                                  !contacts.administration
                                                    .Email) ||
                                                errors[0],
                                              success:
                                                contacts.administration.Email &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="email"
                                                v-model="
                                                  contacts.administration.Email
                                                "
                                                class="form-control"
                                                name="email1"
                                                id="administration_email"
                                                placeholder="Contact Email Address*"
                                              />
                                              <label
                                                for="administration_email"
                                                class="control-label"
                                              >
                                                Email*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  (errors.length &&
                                                    !contacts.administration
                                                      .Email) ||
                                                  errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.administration
                                                    .Email && !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="administrationPhoneNumber"
                                          :rules="
                                            currentContactsTabIndex == 0
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.administration
                                                  .phoneNumber,
                                              success:
                                                contacts.administration
                                                  .phoneNumber,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  contacts.administration
                                                    .phoneNumber
                                                "
                                                class="form-control"
                                                id="administrationPhoneNumber"
                                                placeholder="Phone Number*"
                                              />
                                              <label
                                                for="administrationPhoneNumber"
                                                class="control-label"
                                              >
                                                Phone Number*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.administration
                                                    .phoneNumber
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.administration
                                                    .phoneNumber
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </b-tab>

                              <!-- Finance related issues -->
                              <b-tab title="Finance related issues">
                                <ul class="list-unstyled mb-0">
                                  <li>
                                    <div
                                      class="d-flex align-items-center justify-content-between mb-3"
                                    >
                                      <p class="mb-0 mr-3 custom-switch-text">
                                        Same as Admin
                                      </p>
                                      <div class="custom-switch success-handle">
                                        <input
                                          type="checkbox"
                                          class="custom-switch-input"
                                          id="is_finance_same_as_admin"
                                          v-model="
                                            contacts.finance.isSameAsAdmin
                                          "
                                        />
                                        <label
                                          class="custom-switch-label"
                                          for="is_finance_same_as_admin"
                                        >
                                          <span class="custom-switch-text1">
                                            Yes
                                          </span>
                                          <span class="custom-switch-text2">
                                            No
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </li>
                                  <li v-if="!contacts.finance.isSameAsAdmin">
                                    <div class="row">
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          :name="'finance_country'"
                                          :rules="
                                            currentContactsTabIndex == 1
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div class="country-dropdown">
                                            <div
                                              class="form-group form-select multiselect-grp"
                                              :class="{
                                                errors: errors[0],
                                                success:
                                                  contacts.finance.country &&
                                                  !errors[0],
                                              }"
                                            >
                                              <span class="float-label">
                                                <label for="c">Country*</label>
                                                <multiselect
                                                  placeholder=""
                                                  v-model="
                                                    contacts.finance.country
                                                  "
                                                  :show-labels="false"
                                                  :options="residence_countrys"
                                                  :searchable="false"
                                                  label="name"
                                                  track-by="name"
                                                >
                                                  <template
                                                    slot="option"
                                                    slot-scope="props"
                                                  >
                                                    <span
                                                      :class="
                                                        props.option.flagClass
                                                      "
                                                    ></span>
                                                    <div class="option__desc">
                                                      <span
                                                        class="option__title"
                                                      >
                                                        {{ props.option.name }}
                                                      </span>
                                                    </div>
                                                  </template>
                                                </multiselect>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length && errors[0]
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="
                                                    contacts.finance.country &&
                                                    !errors[0]
                                                  "
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="finance_name"
                                          :rules="
                                            currentContactsTabIndex == 1
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.finance.name,
                                              success: contacts.finance.name,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="contacts.finance.name"
                                                class="form-control"
                                                id="finance_name"
                                                placeholder="Name*"
                                              />
                                              <label
                                                for="finance_name"
                                                class="control-label"
                                              >
                                                Name*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.finance.name
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="contacts.finance.name"
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="finance_email"
                                          :rules="
                                            currentContactsTabIndex == 1
                                              ? 'required|email'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                (errors.length &&
                                                  !contacts.finance.Email) ||
                                                errors[0],
                                              success:
                                                contacts.finance.Email &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="email"
                                                v-model="contacts.finance.Email"
                                                class="form-control"
                                                name="email1"
                                                id="finance_email"
                                                placeholder="Contact Email Address*"
                                              />
                                              <label
                                                for="finance_email"
                                                class="control-label"
                                              >
                                                Email*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  (errors.length &&
                                                    !contacts.finance.Email) ||
                                                  errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.finance.Email &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="financePhoneNumber"
                                          :rules="
                                            currentContactsTabIndex == 1
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.finance.phoneNumber,
                                              success:
                                                contacts.finance.phoneNumber,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  contacts.finance.phoneNumber
                                                "
                                                class="form-control"
                                                id="financePhoneNumber"
                                                placeholder="Phone Number*"
                                              />
                                              <label
                                                for="financePhoneNumber"
                                                class="control-label"
                                              >
                                                Phone Number*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.finance.phoneNumber
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.finance.phoneNumber
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </b-tab>

                              <!-- Customer Service Issues  -->
                              <b-tab title="Customer Service Issues">
                                <ul class="list-unstyled mb-0">
                                  <li>
                                    <div
                                      class="d-flex align-items-center justify-content-between mb-3"
                                    >
                                      <p class="mb-0 mr-3 custom-switch-text">
                                        Same as Admin
                                      </p>
                                      <div class="custom-switch success-handle">
                                        <input
                                          type="checkbox"
                                          class="custom-switch-input"
                                          id="is_customer_same_as_admin"
                                          v-model="
                                            contacts.customerService
                                              .isSameAsAdmin
                                          "
                                        />
                                        <label
                                          class="custom-switch-label"
                                          for="is_customer_same_as_admin"
                                        >
                                          <span class="custom-switch-text1">
                                            Yes
                                          </span>
                                          <span class="custom-switch-text2">
                                            No
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </li>
                                  <li
                                    v-if="
                                      !contacts.customerService.isSameAsAdmin
                                    "
                                  >
                                    <div class="row">
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          :name="'customerService_country'"
                                          :rules="
                                            currentContactsTabIndex == 2
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div class="country-dropdown">
                                            <div
                                              class="form-group form-select multiselect-grp"
                                              :class="{
                                                errors: errors[0],
                                                success:
                                                  contacts.customerService
                                                    .country && !errors[0],
                                              }"
                                            >
                                              <span class="float-label">
                                                <label for="c">Country*</label>
                                                <multiselect
                                                  placeholder=""
                                                  v-model="
                                                    contacts.customerService
                                                      .country
                                                  "
                                                  :show-labels="false"
                                                  :options="residence_countrys"
                                                  :searchable="false"
                                                  label="name"
                                                  track-by="name"
                                                >
                                                  <template
                                                    slot="option"
                                                    slot-scope="props"
                                                  >
                                                    <span
                                                      :class="
                                                        props.option.flagClass
                                                      "
                                                    ></span>
                                                    <div class="option__desc">
                                                      <span
                                                        class="option__title"
                                                      >
                                                        {{ props.option.name }}
                                                      </span>
                                                    </div>
                                                  </template>
                                                </multiselect>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length && errors[0]
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="
                                                    contacts.customerService
                                                      .country && !errors[0]
                                                  "
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="customerService_name"
                                          :rules="
                                            currentContactsTabIndex == 2
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.customerService.name,
                                              success:
                                                contacts.customerService.name,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  contacts.customerService.name
                                                "
                                                class="form-control"
                                                id="customerService_name"
                                                placeholder="Name*"
                                              />
                                              <label
                                                for="customerService_name"
                                                class="control-label"
                                              >
                                                Name*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.customerService.name
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.customerService.name
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="customerService_email"
                                          :rules="
                                            currentContactsTabIndex == 2
                                              ? 'required|email'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                (errors.length &&
                                                  !contacts.customerService
                                                    .Email) ||
                                                errors[0],
                                              success:
                                                contacts.customerService
                                                  .Email && !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="email"
                                                v-model="
                                                  contacts.customerService.Email
                                                "
                                                class="form-control"
                                                name="email1"
                                                id="customerService_email"
                                                placeholder="Contact Email Address*"
                                              />
                                              <label
                                                for="customerService_email"
                                                class="control-label"
                                              >
                                                Email*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  (errors.length &&
                                                    !contacts.customerService
                                                      .Email) ||
                                                  errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.customerService
                                                    .Email && !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="customerPhoneNumber"
                                          :rules="
                                            currentContactsTabIndex == 2
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.customerService
                                                  .phoneNumber,
                                              success:
                                                contacts.customerService
                                                  .phoneNumber,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  contacts.customerService
                                                    .phoneNumber
                                                "
                                                class="form-control"
                                                id="customerPhoneNumber"
                                                placeholder="Phone Number*"
                                              />
                                              <label
                                                for="customerPhoneNumber"
                                                class="control-label"
                                              >
                                                Phone Number*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.customerService
                                                    .phoneNumber
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.customerService
                                                    .phoneNumber
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </b-tab>

                              <!-- Technical Issues  -->
                              <b-tab title="Technical Issues">
                                <ul class="list-unstyled mb-0">
                                  <li>
                                    <div
                                      class="d-flex align-items-center justify-content-between mb-3"
                                    >
                                      <p class="mb-0 mr-3 custom-switch-text">
                                        Same as Admin
                                      </p>
                                      <div class="custom-switch success-handle">
                                        <input
                                          type="checkbox"
                                          class="custom-switch-input"
                                          id="is_technical_same_as_admin"
                                          v-model="
                                            contacts.technical.isSameAsAdmin
                                          "
                                        />
                                        <label
                                          class="custom-switch-label"
                                          for="is_technical_same_as_admin"
                                        >
                                          <span class="custom-switch-text1">
                                            Yes
                                          </span>
                                          <span class="custom-switch-text2">
                                            No
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  </li>
                                  <li v-if="!contacts.technical.isSameAsAdmin">
                                    <div class="row">
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          :name="'technical_country'"
                                          :rules="
                                            currentContactsTabIndex == 3
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div class="country-dropdown">
                                            <div
                                              class="form-group form-select multiselect-grp"
                                              :class="{
                                                errors: errors[0],
                                                success:
                                                  contacts.technical.country &&
                                                  !errors[0],
                                              }"
                                            >
                                              <span class="float-label">
                                                <label for="c">Country*</label>
                                                <multiselect
                                                  placeholder=""
                                                  v-model="
                                                    contacts.technical.country
                                                  "
                                                  :show-labels="false"
                                                  :options="residence_countrys"
                                                  :searchable="false"
                                                  label="name"
                                                  track-by="name"
                                                >
                                                  <template
                                                    slot="option"
                                                    slot-scope="props"
                                                  >
                                                    <span
                                                      :class="
                                                        props.option.flagClass
                                                      "
                                                    ></span>
                                                    <div class="option__desc">
                                                      <span
                                                        class="option__title"
                                                      >
                                                        {{ props.option.name }}
                                                      </span>
                                                    </div>
                                                  </template>
                                                </multiselect>
                                                <i
                                                  class="fa fa-times"
                                                  v-if="
                                                    errors.length && errors[0]
                                                  "
                                                ></i>
                                                <i
                                                  class="fa fa-check"
                                                  v-if="
                                                    contacts.technical
                                                      .country && !errors[0]
                                                  "
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="technical_name"
                                          :rules="
                                            currentContactsTabIndex == 3
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.technical.name,
                                              success: contacts.technical.name,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  contacts.technical.name
                                                "
                                                class="form-control"
                                                id="technical_name"
                                                placeholder="Name*"
                                              />
                                              <label
                                                for="technical_name"
                                                class="control-label"
                                              >
                                                Name*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.technical.name
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="contacts.technical.name"
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="technical_email"
                                          :rules="
                                            currentContactsTabIndex == 3
                                              ? 'required|email'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                (errors.length &&
                                                  !contacts.technical.Email) ||
                                                errors[0],
                                              success:
                                                contacts.technical.Email &&
                                                !errors[0],
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="email"
                                                v-model="
                                                  contacts.technical.Email
                                                "
                                                class="form-control"
                                                name="email1"
                                                id="technical_email"
                                                placeholder="Contact Email Address*"
                                              />
                                              <label
                                                for="technical_email"
                                                class="control-label"
                                              >
                                                Email*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  (errors.length &&
                                                    !contacts.technical
                                                      .Email) ||
                                                  errors[0]
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.technical.Email &&
                                                  !errors[0]
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        <ValidationProvider
                                          name="technicalphoneNumber"
                                          :rules="
                                            currentContactsTabIndex == 3
                                              ? 'required'
                                              : ''
                                          "
                                          v-slot="{ errors }"
                                        >
                                          <div
                                            class="form-group"
                                            :class="{
                                              errors:
                                                errors.length &&
                                                !contacts.technical.phoneNumber,
                                              success:
                                                contacts.technical.phoneNumber,
                                            }"
                                          >
                                            <span class="float-label">
                                              <input
                                                type="text"
                                                v-model="
                                                  contacts.technical.phoneNumber
                                                "
                                                class="form-control"
                                                id="technicalphoneNumber"
                                                placeholder="Phone Number*"
                                              />
                                              <label
                                                for="technicalphoneNumber"
                                                class="control-label"
                                              >
                                                Phone Number*
                                              </label>
                                              <div class="line"></div>
                                              <i
                                                class="fa fa-times"
                                                v-if="
                                                  errors.length &&
                                                  !contacts.technical
                                                    .phoneNumber
                                                "
                                              ></i>
                                              <i
                                                class="fa fa-check"
                                                v-if="
                                                  contacts.technical.phoneNumber
                                                "
                                              ></i>
                                            </span>
                                          </div>
                                        </ValidationProvider>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </b-tab>
                            </b-tabs>
                          </li>
                          <li class="text-right">
                            <b-button
                              type="submit"
                              variant="primary ml-1"
                              size="lg"
                            >
                              Confirm & Save
                            </b-button>
                          </li>
                        </ul>
                      </form>
                    </ValidationObserver>
                  </b-collapse>
                </div>

                <!-- All Form Submition  -->
                <div
                  class="profile-collapse-list no-shadow"
                  :class="{ active: documents.documentsSubmit }"
                >
                  <div class="final-submit">
                    <div class="form-group mb-0">
                      <label class="fancy-checkbox new-fancy">
                        <input
                          type="checkbox"
                          @click="checkIsChecked($event)"
                        />
                        <span>
                          I confirm the information provided is true and
                          accurate
                        </span>
                      </label>
                      <span class="text-danger">
                        {{ allformdatas.errorMsg }}
                      </span>
                    </div>
                    <b-button
                      variant="primary"
                      size="lg"
                      @click="allFormSubmit()"
                    >
                      SUBMIT ALL FOR REVIEW
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import { EventBus } from "@/plugins/event-bus.js";
import "@/plugins/sweetalert2";
import "@/plugins/vee-validate";
export default {
  name: "SetupProfileComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    "dropdown-datepicker": () =>
      import("vue-dropdown-datepicker/src/dropdown-datepicker.vue"),
  },
  data() {
    return {
      toggleSidebarTheme: "",
      //account holder
      title_options: [
        "Mr.",
        "Mrs.",
        "Miss",
        "Dr.",
        "Ms.",
        "Prof.",
        "Rev.",
        "Lady",
        "Sir",
        "Capt.",
        "Major",
        "Lt.-Col.",
        "Col.",
        "Lady",
        "Lt.-Cmdr.",
        "Hon.",
        "Cmdr.",
        "Flt. Lt.",
        "Brgdr.",
        "Judge",
        "Lord",
      ],
      accountHolder: {
        Icon: "",
        accountHolderStatus: "Section Incomplete",
        accountHolderStatusColor: "status-incomplete",
        accountHolderIsSubmit: false,
        title_selected: null,
        first_name: "",
        middle_name: "",
        last_name: "",
        gender: null,
        date_of_birth: null,
        addressLine1: "",
        addressLine2: "",
        town: "",
        city: "",
        sprc: "",
        postCode: "",
        your_role: null,
        countryofBirth: null,
        countryofResidence: null,
        mobile_number: "",
        email_address: "",
      },

      countryofBirth_options: [
        { name: "India", flagClass: "flag-icon flag-icon-in fi-xl fi-round" },
        {
          name: "United Kingdom",
          flagClass: "flag-icon flag-icon-gb fi-xl fi-round",
        },
        { name: "France", flagClass: "flag-icon flag-icon-fr fi-xl fi-round" },
        {
          name: "United States",
          flagClass: "flag-icon flag-icon-us fi-xl fi-round",
        },
      ],

      countryofResidence_options: [
        { name: "India", flagClass: "flag-icon flag-icon-in fi-xl fi-round" },
        {
          name: "United Kingdom",
          flagClass: "flag-icon flag-icon-gb fi-xl fi-round",
        },
        { name: "France", flagClass: "flag-icon flag-icon-fr fi-xl fi-round" },
        {
          name: "United States",
          flagClass: "flag-icon flag-icon-us fi-xl fi-round",
        },
      ],
      gender_options: ["Male", "Female"],
      role_options: [
        "Owner",
        "Founder and CEO",
        "CEO/MD",
        "CTO/Head of IT",
        "CMO/Sales/Marketing Director",
        "Business Development Manager",
        "Director",
        "Manager",
      ],
      //business information
      businessInfo: {
        Icon: "",
        businessInfoStatus: "Section Incomplete",
        businessInfoStatusColor: "status-incomplete",
        businessInfoIsSubmit: false,
        businessTypeTitle: "Business",
        showOtherInput: false,
        residenceCountrys: null,
        businessType: null,
        otherBusinessType: "",
        businessOrganisation: "",
        changedBusinessName: false,
        previousBusinessName: "",
        registerBusinessDate: null,
        startTrading: null,
        displaytradingName: false,
        tradingName: "",
      },

      residence_countrys: [
        { name: "India", flagClass: "flag-icon flag-icon-in fi-xl fi-round" },
        {
          name: "United Kingdom",
          flagClass: "flag-icon flag-icon-gb fi-xl fi-round",
        },
        { name: "France", flagClass: "flag-icon flag-icon-fr fi-xl fi-round" },
        {
          name: "United States",
          flagClass: "flag-icon flag-icon-us fi-xl fi-round",
        },
      ],

      businesstype_options: [
        {
          id: 1,
          businessType: "business",
          businessTypeTitle: "Registered Sole Proprietorship",
        },
        {
          id: 2,
          businessType: "business",
          businessTypeTitle: "Unregistered Solver Proprietorship",
        },
        {
          id: 3,
          businessType: "business",
          businessTypeTitle: "Private Limited Liability Company",
        },
        {
          id: 4,
          businessType: "business",
          businessTypeTitle: "Public Limited Company",
        },
        {
          id: 5,
          businessType: "business",
          businessTypeTitle: "Limited Liability Partnership",
        },
        {
          id: 6,
          businessType: "business",
          businessTypeTitle: "Unlimited Liability Company",
        },
        {
          id: 7,
          businessType: "organisation",
          businessTypeTitle: "Alumni Association",
        },
        {
          id: 8,
          businessType: "organisation",
          businessTypeTitle: "Club or Association",
        },
        {
          id: 9,
          businessType: "organisation",
          businessTypeTitle: "Registered Charity",
        },
        {
          id: 10,
          businessType: "organisation",
          businessTypeTitle: "Unregistered Charity",
        },
        {
          id: 11,
          businessType: "organisation",
          businessTypeTitle: "Religious Organisation",
        },
        {
          id: 12,
          businessType: "organisation",
          businessTypeTitle: "Membership Organisation",
        },
        {
          id: 12,
          businessType: "business",
          businessTypeTitle: "Branch or External Company",
        },
        {
          id: 13,
          businessType: "business",
          businessTypeTitle: "Government Institutions",
        },
        {
          id: 14,
          businessType: "business",
          businessTypeTitle: "Trust Funds",
        },
        {
          id: 15,
          businessType: "other",
          businessTypeTitle: "Other – Please Specify",
        },
      ],

      //Business Contact Details
      businessContact: {
        Icon: "",
        businessContactStatus: "Section Incomplete",
        businessContactStatusColor: "status-incomplete",
        businessContactIsSubmit: false,
        addressLine1: "",
        addressLine2: "",
        town: "",
        city: "",
        sprc: "",
        postCode: "",
        tradingAddress: false,
        tradingAddressInput1: "",
        tradingAddressInput2: "",
        tradingTown: "",
        tradingCity: "",
        tradingSprc: "",
        tradingPostCode: "",
        mobileNumber: "",
        email: "",
        websiteURLDisplay: false,
        websiteURL: "",
      },

      //Tell us about your needs
      account: {
        Icon: "",
        accountStatus: "Section Incomplete",
        accountStatusColor: "status-incomplete",
        accountIsSubmit: false,
        useOfAccount: "",
        activeBankDeposits: false,
        activeMobileMoney: false,
        activeAirtime: false,
        activeSms: false,
        activeUssd: false,
        activeMobileMoneyCollections: false,
        activevirtualPOS: false,
        activeQRCode: false,
        activeInternetData: false,
        activeBill: false,
      },

      //Controllers of your Business
      controllersSubmit: false,
      controllersStatus: "Section Incomplete",
      controllersStatusColor: "status-incomplete",
      controllersIcon: "",
      directors: [
        {
          first_name: null,
          middle_name: "",
          last_name: "",
          date_of_appointment: null,
          occupation: "",
          nationality: null,
          country_of_residence: null,
          addressLine1: "",
          addressLine2: "",
          town: "",
          city: "",
          sprc: "",
          postCode: "",
          date_of_birth: "",
          countryofBirth: null,
          isServingShareholder: false,
          ownership: "",
        },
      ],
      nationality_countrys: [
        { name: "India", flagClass: "flag-icon flag-icon-in fi-xl fi-round" },
        {
          name: "United Kingdom",
          flagClass: "flag-icon flag-icon-gb fi-xl fi-round",
        },
        { name: "France", flagClass: "flag-icon flag-icon-fr fi-xl fi-round" },
        {
          name: "United States",
          flagClass: "flag-icon flag-icon-us fi-xl fi-round",
        },
      ],
      currentTabIndex: 0,
      individuals: [
        {
          first_name: "",
          middle_name: "",
          last_name: "",
          ownership: "",
          occupation: "",
          nationality: null,
          country_of_residence: null,
          addressLine1: "",
          addressLine2: "",
          town: "",
          city: "",
          sprc: "",
          postCode: "",
          date_of_birth: null,
          countryofBirth: null,
        },
      ],

      corporates: [
        {
          companyName: "",
          country_of_residence: null,
          addressLine1: "",
          addressLine2: "",
          town: "",
          city: "",
          sprc: "",
          postCode: "",
        },
      ],

      ownerDatas: [
        {
          type: "",
          typeIndex: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          ownership: "",
          occupation: "",
          nationality: null,
          country_of_residence: null,
          addressLine1: "",
          addressLine2: "",
          town: "",
          city: "",
          sprc: "",
          postCode: "",
          date_of_birth: "",
          countryofBirth: null,
        },
      ],

      //Business Structure, Condition and Size
      businessStructure: {
        Icon: "",
        businessStructureStatus: "Section Incomplete",
        businessStructureStatusColor: "status-incomplete",
        businessStructureSubmit: false,
        parentBusinessName: false,
        parentProfile: "",
        subsidiary: false,
        subsidiaryName: "",
        companyStatus: null,
        NoOfEmp: null,
        CurrentBTurnover: null,
        ExpectedBTurnover: null,
        size: null,
      },
      companyStatus_option: [
        "Active",
        "Dormant",
        "Disqualified",
        "Suspended",
        "Discontinued",
        "Inactive",
      ],
      NoOfEmp_option: [
        "1 - 5",
        "5 - 10",
        "10 - 20",
        "20 - 50",
        "50 - 100",
        "100+",
      ],
      CurrentBTurnover_option: [
        "0 - 1 Million GBP",
        "1 - 5 Million GBP",
        "5 - 10 Million GBP",
        "10 - 20 Million GBP",
        "20 - 50 Million GBP",
        "50 - 100 Million GBP",
        "100+ Million GBP",
      ],
      ExpectedBTurnover_option: [
        "0 - 1 Million GBP",
        "1 - 5 Million GBP",
        "5 - 10 Million GBP",
        "10 - 20 Million GBP",
        "20 - 50 Million GBP",
        "50 - 100 Million GBP",
        "100+ Million GBP",
      ],
      size_option: ["Micro", "Small", "Medium", "Large"],

      //Your Business and Regulations
      regulations: {
        regulationsStatus: "Section Incomplete",
        regulationsStatusColor: "status-incomplete",
        regulationsSubmit: false,
        industryClassification: null,
        ISIC_code: null,
        registration_Number: "",
        Tax_ID: "",
        isRegulated: false,
        regulatedNumber: "",
        isSalesTax: false,
        taxNumber: "",
        isAMLPolicy: false,
        AMLPolicyNumber: "",
        isDataProtection: false,
        dataProtectionNumber: "",
        isPCICertified: false,
        certificationDate: null,
        isISOCertified: false,
        ISOCertifiedDate: "",
      },
      industryClassification_option: [
        "Hospitality",
        "Taxes & Legal",
        "Industrial & Warehouse",
        "Real Estate",
      ],
      ISICCode_option: ["NACE – EU", "NAICS – US", "UKSIC - UK"],

      //Compliance Declarations
      complianceDec: {
        Icon: "",
        complianceDecStatus: "Section Incomplete",
        complianceDecStatusColor: "status-incomplete",
        complianceDecSubmit: false,
        isPossibilityCrime: false,
        isPoliticallyExposed: false,
        isBankrupt: false,
        isTerrorism: false,
        isLaundering: false,
        isWeapons: false,
      },

      //Supporting Documents
      documents: {
        documentsStatus: "Section Incomplete",
        documentsStatusColor: "status-incomplete",
        Icon: "",
        documentType: "",
        wealthType: "",
      },

      documentTypeList: [
        {
          type: "article_of_association",
          name: "Article of Association",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
        {
          type: "memorandum_of_association",
          name: "Memorandum of Association",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
        //director 1
        {
          type: "director_id_1",
          name: "Director - John - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "director_address_1",
          name: "Director - John -  Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        //director 2
        {
          type: "director_id_2",
          name: "Director - David - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "director_address_2",
          name: "Director - David - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        //shareholders 1
        {
          type: "shareholders_id_1",
          name: "Shareholder - John - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_address_1",
          name: "Shareholder - John - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_wealth_1",
          name: "Shareholder - John - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "swealth1_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth1_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth1_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //shareholders 2
        {
          type: "shareholders_id_2",
          name: "Shareholder - David - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_address_2",
          name: "Shareholder - David - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_wealth_2",
          name: "Shareholder - David - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "swealth2_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth2_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth2_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //Beneficial Owners 1
        {
          type: "owners_id_1",
          name: "UBO - John - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_address_1",
          name: "UBO - John - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_wealth_1",
          name: "UBO - John - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "owealth1_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth1_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth1_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //Beneficial Owners 2
        {
          type: "owners_id_2",
          name: "UBO - David - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_address_2",
          name: "UBO - David - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthDocuments: [],
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_wealth_2",
          name: "UBO - David - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "owealth2_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth2_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth2_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //licences
        {
          type: "licences",
          name: "Proof of Licences held, if any",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
        //financial aaccounts
        {
          type: "financial_accounts",
          name: "Financial Accounts",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
      ],

      documentOptions: [
        {
          type: "article_of_association",
          name: "Article of Association",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
        {
          type: "memorandum_of_association",
          name: "Memorandum of Association",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
        //director 1
        {
          type: "director_id_1",
          name: "Director - John - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "director_address_1",
          name: "Director - John -  Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        //director 2
        {
          type: "director_id_2",
          name: "Director - David - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "director_address_2",
          name: "Director - David - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        //shareholders 1
        {
          type: "shareholders_id_1",
          name: "Shareholder - John - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_address_1",
          name: "Shareholder - John - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_wealth_1",
          name: "Shareholder - John - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "swealth1_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth1_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth1_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //shareholders 2
        {
          type: "shareholders_id_2",
          name: "Shareholder - David - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_address_2",
          name: "Shareholder - David - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "shareholders_wealth_2",
          name: "Shareholder - David - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "swealth2_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth2_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "swealth2_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //Beneficial Owners 1
        {
          type: "owners_id_1",
          name: "UBO - John - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_address_1",
          name: "UBO - John - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_wealth_1",
          name: "UBO - John - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "owealth1_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth1_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth1_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //Beneficial Owners 2
        {
          type: "owners_id_2",
          name: "UBO - David - ID",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_address_2",
          name: "UBO - David - Proof of Address",
          documents: [],
          documents_count: 0,
          wealthDocuments: [],
          isBusiness: true,
          isUploaded: false,
        },
        {
          type: "owners_wealth_2",
          name: "UBO - David - Source of Wealth",
          documents: [],
          documents_count: 0,
          isBusiness: true,
          isUploaded: false,
          wealthNames: [
            {
              wealthType: "owealth2_document1",
              name: "Document 1",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth2_document2",
              name: "Document 2",
              wealthDocuments: [],
            },
            {
              wealthType: "owealth2_document3",
              name: "Document 3",
              wealthDocuments: [],
            },
          ],
        },
        //licences
        {
          type: "licences",
          name: "Proof of Licences held, if any",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
        //financial aaccounts
        {
          type: "financial_accounts",
          name: "Financial Accounts",
          documents: [],
          documents_count: 0,
          wealthNames: null,
          isBusiness: false,
          isUploaded: false,
        },
      ],

      sourceWealth_options: [
        {
          id: 1,
          document: "Document-1",
        },
        {
          id: 2,
          document: "Document-2",
        },
        {
          id: 3,
          document: "Document-3",
        },
        {
          id: 4,
          document: "Document-4",
        },
        {
          id: 5,
          document: "Document-5",
        },
      ],

      UBOSourceWealth_options: [
        {
          id: 1,
          document: "Document-1",
        },
        {
          id: 2,
          document: "Document-2",
        },
        {
          id: 3,
          document: "Document-3",
        },
        {
          id: 4,
          document: "Document-4",
        },
        {
          id: 5,
          document: "Document-5",
        },
      ],

      //Finally, in case we need to reach you who should we contact?
      currentContactsTabIndex: 0,
      contacts: {
        Icon: "",
        contactsStatus: "Section Incomplete",
        contactsStatusColor: "status-incomplete",
        contactSubmit: false,
        administration: {
          country: null,
          name: "",
          Email: "",
          phoneNumber: "",
        },

        finance: {
          isSameAsAdmin: true,
          country: null,
          name: "",
          Email: "",
          phoneNumber: "",
        },

        customerService: {
          isSameAsAdmin: true,
          country: null,
          name: "",
          Email: "",
          phoneNumber: "",
        },

        technical: {
          isSameAsAdmin: true,
          country: null,
          name: "",
          Email: "",
          phoneNumber: "",
        },
      },

      allformdatas: {
        IsCheckedCheckbox: false,
        errorMsg: "",
      },

      previousOwnership: null,
      selectedItemArray: [],
      documentError: false,
    };
  },
  methods: {
    onChangeFileUpload(type) {
      if (type) {
        let index = this.selectedItemArray.wealthNames.findIndex(
          (i) => i.wealthType == type.wealthType,
        );
        this.selectedItemArray.wealthNames[index].wealthDocuments.push(
          ...this.$refs.file.files,
        );
        this.documents.wealthType = "";
        this.selectedItemArray.documents_count += this.$refs.file.files.length;
      } else {
        if (!this.selectedItemArray) {
          this.selectedItemArray = {};
          this.selectedItemArray.documents = [];
          this.selectedItemArray.documents_count = 0;
        }
        this.selectedItemArray.documents.push(...this.$refs.file.files);
        this.selectedItemArray.documents_count += this.$refs.file.files.length;
      }
      this.documents.documentType = "";
      this.updateDocumentOptions();
    },

    removeUploadFiles(e, typeArray, fieIndex, wealthDocType) {
      this.documentTypeList.map((item) => {
        if (item.type == typeArray && wealthDocType) {
          item.wealthNames.map((wealthItem) => {
            if (wealthItem.wealthType == wealthDocType) {
              wealthItem.wealthDocuments.splice(fieIndex, 1);
              item.documents_count--;
            }
          });
        } else if (item.type == typeArray) {
          item.documents.splice(fieIndex, 1);
          item.documents_count--;
        }
      });
      this.updateDocumentOptions();
    },

    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },

    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },

    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChangeFileUpload(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },

    onChangeCheckType(selectedItems) {
      this.$refs.file.value = null;
      this.selectedItemArray = selectedItems;
    },

    //account holder form data
    accountHolderForm() {
      this.accountHolder.accountHolderIsSubmit = true;
      this.accountHolder.accountHolderStatus = "Pending Review";
      this.accountHolder.accountHolderStatusColor = "status-pending";
    },

    //business information form data
    businessInfoForm() {
      this.businessInfo.businessInfoIsSubmit = true;
      this.businessInfo.businessInfoStatus = "Pending Review";
      this.businessInfo.businessInfoStatusColor = "status-pending";
    },

    onChangeBusiness(businesstypeOptions) {
      if (businesstypeOptions.businessType == "business") {
        this.businessInfo.businessTypeTitle = "Business";
      } else {
        this.businessInfo.businessTypeTitle = "Organisation";
      }

      if (businesstypeOptions.businessType == "other") {
        this.businessInfo.showOtherInput = true;
      } else {
        this.businessInfo.showOtherInput = false;
      }
      this.updateDocumentOptions();
    },

    //Business Contact Details
    businessContactForm() {
      this.businessContact.businessContactIsSubmit = true;
      this.businessContact.businessContactStatus = "Pending Review";
      this.businessContact.businessContactStatusColor = "status-pending";
    },

    //Tell us about your needs
    accountForm() {
      this.account.accountIsSubmit = true;
      this.account.accountStatus = "Pending Review";
      this.account.accountStatusColor = "status-pending";
    },

    ServiceActive(selectedService) {
      if (selectedService == "bank-deposits") {
        this.account.activeBankDeposits = !this.account.activeBankDeposits;
      } else if (selectedService == "mobile-money") {
        this.account.activeMobileMoney = !this.account.activeMobileMoney;
      } else if (selectedService == "airtime") {
        this.account.activeAirtime = !this.account.activeAirtime;
      } else if (selectedService == "sms") {
        this.account.activeSms = !this.account.activeSms;
      } else if (selectedService == "ussd") {
        this.account.activeUssd = !this.account.activeUssd;
      } else if (selectedService == "mobile-money-collections") {
        this.account.activeMobileMoneyCollections =
          !this.account.activeMobileMoneyCollections;
      } else if (selectedService == "virtual-POS") {
        this.account.activevirtualPOS = !this.account.activevirtualPOS;
      } else if (selectedService == "qr-code-payments") {
        this.account.activeQRCode = !this.account.activeQRCode;
      } else if (selectedService == "internet-data-bundle") {
        this.account.activeInternetData = !this.account.activeInternetData;
      } else if (selectedService == "bill-payments") {
        this.account.activeBill = !this.account.activeBill;
      }
    },

    //Controlers submit form
    controllersForm() {
      this.controllersSubmit = true;
      this.controllersStatus = "Pending Review";
      this.controllersStatusColor = "status-pending";
    },

    //add Directors
    addDirector() {
      this.directors.push({
        first_name: "",
        middle_name: "",
        last_name: "",
        date_of_appointment: null,
        occupation: "",
        nationality: "",
        country_of_residence: "",
        addressLine1: "",
        addressLine2: "",
        town: "",
        city: "",
        sprc: "",
        postCode: "",
        date_of_birth: "",
        countryofBirth: "",
        isServingShareholder: false,
        ownership: "",
      });
    },

    //remove Directors
    removeDirector: function (index) {
      this.directors.splice(index, 1);
    },

    //add Individuals
    addIndividuals() {
      this.individuals.push({
        first_name: "",
        middle_name: "",
        last_name: "",
        ownership: "",
        occupation: "",
        nationality: "",
        country_of_residence: "",
        residentialAddress: "",
        date_of_birth: null,
        countryofBirth: "",
      });
    },

    //remove Individuals
    removeIndividuals: function (index) {
      this.individuals.splice(index, 1);
    },

    //add Corporate
    addCorporate() {
      this.corporates.push({
        companyName: "",
        country_of_residence: "",
        address: "",
      });
    },

    //remove Individuals
    removeCorporate: function (index) {
      this.corporates.splice(index, 1);
    },

    //add Ultimate Beneficial Owner
    addUBO() {
      this.ownerDatas.push({
        first_name: "",
        middle_name: "",
        last_name: "",
        ownership: "",
        occupation: "",
        nationality: "",
        country_of_residence: "",
        addressLine1: "",
        addressLine2: "",
        town: "",
        city: "",
        sprc: "",
        postCode: "",
        date_of_birth: "",
        countryofBirth: "",
      });
    },

    //remove Ultimate Beneficial Owner
    removeUBO: function (index) {
      this.ownerDatas.splice(index, 1);
    },

    //Check shareholder Percentage
    checkSharholderOwnership(ownershipInputValue, index, type) {
      if (type == "director") {
        if (ownershipInputValue > 25) {
          this.$swal
            .fire({
              title: "Is the Shareholder Ultimate Business Owner?",
              showCancelButton: true,
              confirmButtonColor: "#22af46",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            })
            .then((result) => {
              /* yes section */
              if (result.isConfirmed) {
                let newUBO = {};
                ((newUBO.first_name = this.directors[index].first_name),
                  (newUBO.middle_name = this.directors[index].middle_name),
                  (newUBO.last_name = this.directors[index].last_name),
                  (newUBO.ownership = this.directors[index].ownership),
                  (newUBO.occupation = this.directors[index].occupation),
                  (newUBO.nationality = this.directors[index].nationality),
                  (newUBO.country_of_residence =
                    this.directors[index].country_of_residence),
                  (newUBO.addressLine1 = this.directors[index].addressLine1),
                  (newUBO.addressLine2 = this.directors[index].addressLine2),
                  (newUBO.town = this.directors[index].town),
                  (newUBO.city = this.directors[index].city),
                  (newUBO.sprc = this.directors[index].sprc),
                  (newUBO.postCode = this.directors[index].postCode),
                  (newUBO.date_of_birth = this.directors[index].date_of_birth),
                  (newUBO.countryofBirth =
                    this.directors[index].countryofBirth));
                let that = this;
                if (
                  this.ownerDatas.length == 1 &&
                  this.ownerDatas[0].ownership === ""
                ) {
                  this.ownerDatas = [newUBO];
                  setTimeout(function () {
                    let uboIndex = that.ownerDatas.length - 1;
                    that.$refs["ubopicker" + uboIndex][0].day = parseInt(
                      that.$refs["directorPicker" + index][0].day,
                    );
                    that.$refs["ubopicker" + uboIndex][0].month = parseInt(
                      that.$refs["directorPicker" + index][0].month,
                    );
                    that.$refs["ubopicker" + uboIndex][0].year = parseInt(
                      that.$refs["directorPicker" + index][0].year,
                    );
                  }, 1000);
                } else {
                  this.ownerDatas.push(newUBO);
                  setTimeout(function () {
                    let uboIndex = that.ownerDatas.length - 1;
                    that.$refs["ubopicker" + uboIndex][0].day = parseInt(
                      that.$refs["directorPicker" + index][0].day,
                    );
                    that.$refs["ubopicker" + uboIndex][0].month = parseInt(
                      that.$refs["directorPicker" + index][0].month,
                    );
                    that.$refs["ubopicker" + uboIndex][0].year = parseInt(
                      that.$refs["directorPicker" + index][0].year,
                    );
                  }, 1000);
                }
              }
            });
        } else {
          /* remove value when ownership less than 25 */
          this.ownerDatas.map((ownerDatum, ownerIndex) => {
            if (
              this.directors[index].first_name == ownerDatum.first_name &&
              this.directors[index].middle_name == ownerDatum.middle_name &&
              this.directors[index].last_name == ownerDatum.last_name
            ) {
              if (this.ownerDatas.length > 0) {
                this.ownerDatas.splice(ownerIndex, 1);
              } else {
                ((this.ownerDatas[ownerIndex].first_name = ""),
                  (this.ownerDatas[ownerIndex].middle_name = ""),
                  (this.ownerDatas[ownerIndex].last_name = ""),
                  (this.ownerDatas[ownerIndex].ownership = ""),
                  (this.ownerDatas[ownerIndex].occupation = ""),
                  (this.ownerDatas[ownerIndex].nationality = ""),
                  (this.ownerDatas[ownerIndex].country_of_residence = ""),
                  (this.ownerDatas[ownerIndex].addressLine1 = ""),
                  (this.ownerDatas[ownerIndex].addressLine2 = ""),
                  (this.ownerDatas[ownerIndex].town = ""),
                  (this.ownerDatas[ownerIndex].city = ""),
                  (this.ownerDatas[ownerIndex].sprc = ""),
                  (this.ownerDatas[ownerIndex].postCode = ""),
                  (this.ownerDatas[ownerIndex].residentialAddress = ""),
                  (this.ownerDatas[ownerIndex].date_of_birth = ""),
                  (this.$refs["ubopicker" + ownerIndex][0].day = ""),
                  (this.$refs["ubopicker" + ownerIndex][0].month = ""),
                  (this.$refs["ubopicker" + ownerIndex][0].year = ""),
                  (this.ownerDatas[ownerIndex].countryofBirth = ""));
              }
            }
          });
        }
      } else {
        if (ownershipInputValue > 25) {
          this.$swal
            .fire({
              title: "Is the Shareholder Ultimate Business Owner?",
              showCancelButton: true,
              confirmButtonColor: "#22af46",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            })
            .then((result) => {
              /* yes section */
              if (result.isConfirmed) {
                let newUBO = {};
                ((newUBO.first_name = this.individuals[index].first_name),
                  (newUBO.middle_name = this.individuals[index].middle_name),
                  (newUBO.last_name = this.individuals[index].last_name),
                  (newUBO.ownership = this.individuals[index].ownership),
                  (newUBO.occupation = this.individuals[index].occupation),
                  (newUBO.nationality = this.individuals[index].nationality),
                  (newUBO.country_of_residence =
                    this.individuals[index].country_of_residence),
                  (newUBO.addressLine1 = this.individuals[index].addressLine1),
                  (newUBO.addressLine2 = this.individuals[index].addressLine2),
                  (newUBO.town = this.individuals[index].town),
                  (newUBO.city = this.individuals[index].city),
                  (newUBO.sprc = this.individuals[index].sprc),
                  (newUBO.postCode = this.individuals[index].postCode),
                  (newUBO.date_of_birth =
                    this.individuals[index].date_of_birth),
                  (newUBO.countryofBirth =
                    this.individuals[index].countryofBirth));
                let that = this;
                //this.ownerDatas
                if (
                  this.ownerDatas.length == 1 &&
                  this.ownerDatas[0].ownership === ""
                ) {
                  this.ownerDatas = [newUBO];
                  setTimeout(function () {
                    let uboIndex = that.ownerDatas.length - 1;
                    that.$refs["ubopicker" + uboIndex][0].day = parseInt(
                      that.$refs["individualPicker" + index][0].day,
                    );
                    that.$refs["ubopicker" + uboIndex][0].month = parseInt(
                      that.$refs["individualPicker" + index][0].month,
                    );
                    that.$refs["ubopicker" + uboIndex][0].year = parseInt(
                      that.$refs["individualPicker" + index][0].year,
                    );
                  }, 1000);
                } else {
                  this.ownerDatas.push(newUBO);
                  setTimeout(function () {
                    let uboIndex = that.ownerDatas.length - 1;
                    that.$refs["ubopicker" + uboIndex][0].day = parseInt(
                      that.$refs["individualPicker" + index][0].day,
                    );
                    that.$refs["ubopicker" + uboIndex][0].month = parseInt(
                      that.$refs["individualPicker" + index][0].month,
                    );
                    that.$refs["ubopicker" + uboIndex][0].year = parseInt(
                      that.$refs["individualPicker" + index][0].year,
                    );
                  }, 1000);
                }
              }
            });
        } else {
          /* remove value when ownership less than 25 */
          this.ownerDatas.map((ownerDatum, ownerIndex) => {
            if (
              this.individuals[index].first_name == ownerDatum.first_name &&
              this.individuals[index].middle_name == ownerDatum.middle_name &&
              this.individuals[index].last_name == ownerDatum.last_name
            ) {
              if (this.ownerDatas.length > 0) {
                this.ownerDatas.splice(ownerIndex, 1);
              } else {
                ((this.ownerDatas[ownerIndex].first_name = ""),
                  (this.ownerDatas[ownerIndex].middle_name = ""),
                  (this.ownerDatas[ownerIndex].last_name = ""),
                  (this.ownerDatas[ownerIndex].ownership = ""),
                  (this.ownerDatas[ownerIndex].occupation = ""),
                  (this.ownerDatas[ownerIndex].nationality = ""),
                  (this.ownerDatas[ownerIndex].country_of_residence = ""),
                  (this.ownerDatas[ownerIndex].addressLine1 = ""),
                  (this.ownerDatas[ownerIndex].addressLine2 = ""),
                  (this.ownerDatas[ownerIndex].town = ""),
                  (this.ownerDatas[ownerIndex].city = ""),
                  (this.ownerDatas[ownerIndex].sprc = ""),
                  (this.ownerDatas[ownerIndex].postCode = ""),
                  (this.ownerDatas[ownerIndex].residentialAddress = ""),
                  (this.ownerDatas[ownerIndex].date_of_birth = ""),
                  (this.$refs["ubopicker" + ownerIndex][0].day = ""),
                  (this.$refs["ubopicker" + ownerIndex][0].month = ""),
                  (this.$refs["ubopicker" + ownerIndex][0].year = ""),
                  (this.ownerDatas[ownerIndex].countryofBirth = ""));
              }
            }
          });
        }
      }
    },

    handleInput(e, type) {
      let ele = document.getElementById(e.target.id);
      let index = ele.getAttribute("data-index");
      let stringValue = e.target.value.toString();
      let regex = /^[0-9]*(\.[0-9]{0,2})?$/;
      //director
      if (type == "director") {
        if (
          !stringValue.match(regex) &&
          this.directors[index].ownership !== ""
        ) {
          this.directors[index].ownership = this.previousOwnership;
        }
        this.previousOwnership = this.directors[index].ownership;
      } else {
        if (
          !stringValue.match(regex) &&
          this.individuals[index].ownership !== ""
        ) {
          this.individuals[index].ownership = this.previousOwnership;
        }
        this.previousOwnership = this.individuals[index].ownership;
      }
    },

    checkDecimals(e) {
      let stringValue = e.target.value.toString();
      let regex = /^[0-9]*(\.[0-9]{0,1})?$/;
      if (
        !stringValue.match(regex) &&
        e.key != "Backspace" &&
        e.key != "Tab" &&
        e.key != "Control" &&
        e.key != "Shift"
      ) {
        e.preventDefault();
      }
    },

    //Business Structure, Condition and Size
    businessStructureForm() {
      this.businessStructure.businessStructureSubmit = true;
      this.businessStructure.businessStructureStatus = "Pending Review";
      this.businessStructure.businessStructureStatusColor = "status-pending";
    },

    //Your Business and Regulations
    regulationsForm() {
      this.regulations.regulationsSubmit = true;
      this.regulations.regulationsStatus = "Pending Review";
      this.regulations.regulationsStatusColor = "status-pending";
    },

    //Compliance Declarations
    complianceDeclarationsForm() {
      this.complianceDec.complianceDecSubmit = true;
      this.complianceDec.complianceDecStatus = "Pending Review";
      this.complianceDec.complianceDecStatusColor = "status-pending";
    },

    //check checkbox cheked
    checkIsChecked(event) {
      this.allformdatas.IsCheckedCheckbox = event.target.checked;
      if (this.allformdatas.IsCheckedCheckbox) {
        return (this.allformdatas.errorMsg = "");
      }
    },

    //Compliance Declarations
    documentsForm() {
      this.documentError = true;
      let arr = [];
      this.documentOptions.map((iteam) => {
        arr.push(iteam.documents_count);
      });
      if (!arr.includes(0)) {
        this.documents.documentsSubmit = true;
        this.documents.documentsStatus = "Pending Review";
        this.documents.documentsStatusColor = "status-pending";
      }
    },

    onChangeDocument(sourceWealth_options) {
      this.documents.wealthDocumentTitle = sourceWealth_options.document;
    },

    onChangeUBODocument(UBOSourceWealth_options) {
      this.documents.UBOwealthDocumentTitle = UBOSourceWealth_options.document;
    },

    //Finally, in case we need to reach you who should we contact?
    contactForm() {
      this.contacts.contactSubmit = true;
      this.contacts.contactsStatus = "Pending Review";
      this.contacts.contactsStatusColor = "status-pending";
    },

    //all form submit method
    allFormSubmit() {
      if (this.allformdatas.IsCheckedCheckbox) {
        this.accountHolder.accountHolderStatus = "Completed";
        this.accountHolder.accountHolderStatusColor = "status-completed";
        this.accountHolder.Icon = require(`@/assets/complete.svg`);

        this.businessInfo.businessInfoStatus = "Rejected";
        this.businessInfo.businessInfoStatusColor = "status-rejected";
        this.businessInfo.Icon = require(`@/assets/rejected.svg`);

        this.businessContact.businessContactStatus = "Completed";
        this.businessContact.businessContactStatusColor = "status-completed";
        this.businessContact.Icon = require(`@/assets/complete.svg`);

        this.account.accountStatus = "Required more info";
        this.account.accountStatusColor = "status-required";
        this.account.Icon = require(`@/assets/required.svg`);

        this.controllersStatus = "Rejected";
        this.controllersStatusColor = "status-rejected";
        this.controllersIcon = require(`@/assets/rejected.svg`);

        this.businessStructure.businessStructureStatus = "Required more info";
        this.businessStructure.businessStructureStatusColor = "status-required";
        this.businessStructure.Icon = require(`@/assets/required.svg`);

        this.regulations.regulationsStatus = "Completed";
        this.regulations.regulationsStatusColor = "status-completed";
        this.regulations.Icon = require(`@/assets/complete.svg`);

        this.complianceDec.complianceDecStatus = "Section Incomplete";
        this.complianceDec.complianceDecStatusColor = "status-incomplete";
        this.complianceDec.Icon = "";

        this.documents.documentsStatus = "Completed";
        this.documents.documentsStatusColor = "status-completed";
        this.documents.Icon = require(`@/assets/complete.svg`);

        this.contacts.contactsStatus = "Pending Review";
        this.contacts.contactsStatusColor = "status-pending";
        this.contacts.Icon = "";
      } else {
        return (this.allformdatas.errorMsg =
          "Please select checkbox to continue.");
      }
    },

    //Update document upload options
    updateDocumentOptions() {
      let that = this;
      this.documentOptions = [];
      this.documentTypeList.map((item) => {
        if (
          item.documents_count == 0 &&
          (that.businessInfo.businessTypeTitle === "Business" ||
            (that.businessInfo.businessTypeTitle === "Organisation" &&
              !item.isBusiness))
        ) {
          that.documentOptions.push(item);
        }
      });
    },
  },
  computed: {
    //word counter
    wordCounter() {
      let wordCount = this.account.useOfAccount;
      return (
        this.skip_html && (wordCount = wordCount.replace(/<\S[^><]*>/gi, "")),
        this.account.useOfAccount.match(/\w+/g)
          ? this.account.useOfAccount.match(/\w+/g).length
          : 0
      );
    },
    //dark Mode image
    isdarkImage() {
      return this.toggleSidebarTheme == "full-dark"
        ? require(`@/assets/process-w.svg`)
        : require(`@/assets/process.svg`);
    },
  },
  mounted() {
    (EventBus.$on("theme", (theme) => {
      this.toggleSidebarTheme = theme;
    }),
      this.updateDocumentOptions());
  },
};
</script>
